var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonateImage1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 750 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-blood-donation:not(.animated) .animable {opacity: 0;}svg#freepik_stories-blood-donation.animated #freepik--background-complete--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,3s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-blood-donation.animated #freepik--Shadow--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,3s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-blood-donation.animated #freepik--Floor--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,3s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-blood-donation.animated #freepik--Plant--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,3s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-blood-donation.animated #freepik--speech-bubble--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,3s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-blood-donation.animated #freepik--character-3--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,3s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-blood-donation.animated #freepik--character-2--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,3s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-blood-donation.animated #freepik--character-1--inject-34 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,3s Infinite  linear floating;animation-delay: 0s,1s;}            @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "350.24px 193.141px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 49.16,
    y: 49.26,
    width: 166.68,
    height: 275.35,
    fill: "#ebebeb",
    style: {
      transformOrigin: "132.5px 186.935px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 60,
    y: 61.19,
    width: 144.99,
    height: 178.93,
    fill: "#fff",
    style: {
      transformOrigin: "132.495px 150.655px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "66.71 348.73 58.34 348.73 58.34 324.61 73.23 324.61",
    fill: "#ebebeb",
    style: {
      transformOrigin: "65.785px 336.67px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "73.24 324.6 70.83 333.49 58.34 333.49 58.34 324.6",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "65.79px 329.045px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "198.29 348.73 206.66 348.73 206.66 324.61 191.76 324.61",
    fill: "#ebebeb",
    style: {
      transformOrigin: "199.21px 336.67px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "191.76 324.6 194.17 333.49 206.66 333.49 206.66 324.6",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "199.21px 329.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M200.79,255.88q-15.91.24-31.82.32c-10.6.1-21.21.07-31.82.11l.58-.43c0,4,0,7.91,0,11.87l-.07,11.87c-.11,7.91-.22,15.82-.5,23.73-.27-7.91-.38-15.82-.49-23.73l-.07-11.87c0-4-.05-7.91,0-11.87v-.43h.57c10.61,0,21.22,0,31.82.12S190.18,255.72,200.79,255.88Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "168.684px 279.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M137.15,310.12q15.91-.24,31.82-.32c10.61-.1,21.21-.07,31.82-.11l-.58.43c0-3.88,0-7.76,0-11.64l.07-11.64c.11-7.76.22-15.52.49-23.28.27,7.76.38,15.52.49,23.28l.07,11.64c0,3.88.06,7.76,0,11.64v.44h-.58c-10.61,0-21.21,0-31.82-.11S147.76,310.29,137.15,310.12Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "169.253px 287.06px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 144.28,
    y: 275.32,
    width: 4.82,
    height: 13.7,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "146.69px 282.17px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m64.21 255.88q15.9-0.24 31.82-0.31c10.6-0.1 21.21-0.08 31.81-0.12h0.58v0.43 11.87l-0.07 11.87c-0.11 7.91-0.22 15.82-0.5 23.73-0.27-7.91-0.38-15.82-0.49-23.73l-0.07-11.87v-11.87l0.57 0.43c-10.6 0-21.21 0-31.81-0.11s-21.24-0.2-31.84-0.32z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "96.315px 279.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M127.84,310.12q-15.9.25-31.81.32c-10.61.1-21.22.07-31.82.11h-.58v-.44c0-3.88,0-7.76,0-11.64l.07-11.64c.11-7.76.22-15.52.49-23.28.27,7.76.38,15.52.49,23.28l.07,11.64c0,3.88.06,7.76,0,11.64l-.58-.43c10.6,0,21.21,0,31.82.11S117.24,310,127.84,310.12Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "95.735px 287.05px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 115.9,
    y: 275.32,
    width: 4.82,
    height: 13.7,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "118.31px 282.17px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 60,
    y: 109.79,
    width: 144.99,
    height: 1.63,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "132.495px 110.605px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 60,
    y: 151.73,
    width: 144.99,
    height: 1.63,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "132.495px 152.545px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 60,
    y: 193.68,
    width: 144.99,
    height: 1.63,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "132.495px 194.495px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 131.29,
    y: 61.19,
    width: 2.41,
    height: 178.93,
    fill: "#ebebeb",
    style: {
      transformOrigin: "132.495px 150.655px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 152.82,
    y: 131.03,
    width: 12.44,
    height: 20.71,
    fill: "#ebebeb",
    style: {
      transformOrigin: "159.04px 141.385px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 151.12,
    y: 127.51,
    width: 15.85,
    height: 3.52,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "159.045px 129.27px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 154.42,
    y: 135.59,
    width: 9.25,
    height: 12.77,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "159.045px 141.975px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 169.59,
    y: 131.03,
    width: 12.44,
    height: 20.71,
    fill: "#ebebeb",
    style: {
      transformOrigin: "175.81px 141.385px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 167.88,
    y: 127.51,
    width: 15.85,
    height: 3.52,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "175.805px 129.27px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 171.19,
    y: 135.59,
    width: 9.25,
    height: 12.77,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "175.815px 141.975px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 186.36,
    y: 131.03,
    width: 12.44,
    height: 20.71,
    fill: "#ebebeb",
    style: {
      transformOrigin: "192.58px 141.385px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 184.65,
    y: 127.51,
    width: 15.85,
    height: 3.52,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "192.575px 129.27px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 187.95,
    y: 135.59,
    width: 9.25,
    height: 12.77,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "192.575px 141.975px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m64.5 171.33h16.5v17a5.31 5.31 0 0 1-5.31 5.31h-5.88a5.31 5.31 0 0 1-5.31-5.31v-17z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "72.75px 182.485px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 67.96,
    y: 169.11,
    width: 9.56,
    height: 2.28,
    fill: "#ebebeb",
    style: {
      transformOrigin: "72.74px 170.25px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 65.53,
    y: 166.68,
    width: 14.42,
    height: 2.43,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "72.74px 167.895px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 67.14,
    y: 176.74,
    width: 13.84,
    height: 12.07,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "74.06px 182.775px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m82.93 171.33h16.49v17a5.31 5.31 0 0 1-5.31 5.31h-5.87a5.31 5.31 0 0 1-5.31-5.31v-17z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "91.175px 182.485px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 86.4,
    y: 169.11,
    width: 9.56,
    height: 2.28,
    fill: "#ebebeb",
    style: {
      transformOrigin: "91.18px 170.25px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 83.96,
    y: 166.68,
    width: 14.42,
    height: 2.43,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "91.17px 167.895px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 85.57,
    y: 176.74,
    width: 13.84,
    height: 12.07,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "92.49px 182.775px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 155.15,
    y: 213.39,
    width: 20.66,
    height: 26.73,
    fill: "#ebebeb",
    style: {
      transformOrigin: "165.48px 226.755px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "155.15 213.39 175.81 213.39 171.84 207.94 159.11 207.94",
    fill: "#ebebeb",
    style: {
      transformOrigin: "165.48px 210.665px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 156.75,
    y: 202.63,
    width: 17.45,
    height: 5.3,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "165.475px 205.28px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 158.1,
    y: 219.33,
    width: 17.71,
    height: 12.02,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "166.955px 225.34px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 177.36,
    y: 213.39,
    width: 20.66,
    height: 26.73,
    fill: "#ebebeb",
    style: {
      transformOrigin: "187.69px 226.755px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "177.36 213.39 198.02 213.39 194.06 207.94 181.32 207.94",
    fill: "#ebebeb",
    style: {
      transformOrigin: "187.69px 210.665px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 178.96,
    y: 202.63,
    width: 17.45,
    height: 5.3,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "187.685px 205.28px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 180.31,
    y: 219.33,
    width: 17.71,
    height: 12.02,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "189.165px 225.34px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m106.42 109.79h-37a3.86 3.86 0 0 1-3.85-3.86 3.85 3.85 0 0 1 3.85-3.85h37a3.85 3.85 0 0 1 3.85 3.85 3.85 3.85 0 0 1-3.85 3.86z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "87.92px 105.935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m106.42 101.57h-37a3.85 3.85 0 0 1-3.85-3.85 3.86 3.86 0 0 1 3.85-3.86h37a3.85 3.85 0 0 1 3.85 3.86 3.85 3.85 0 0 1-3.85 3.85z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "87.92px 97.715px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m105.78 93.36h-35.78a2.77 2.77 0 0 1-2.77-2.77 2.76 2.76 0 0 1 2.77-2.76h35.75a2.76 2.76 0 0 1 2.76 2.76 2.77 2.77 0 0 1-2.73 2.77z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "87.87px 90.595px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m105.78 87.33h-35.78a2.77 2.77 0 0 1-2.77-2.76 2.77 2.77 0 0 1 2.77-2.77h35.75a2.77 2.77 0 0 1 2.76 2.77 2.77 2.77 0 0 1-2.73 2.76z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "87.87px 84.565px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 407.71,
    cy: 76.55,
    r: 30.25,
    fill: "#ebebeb",
    style: {
      transformOrigin: "407.71px 76.55px",
      transform: "rotate(-71.39deg)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 409.1,
    cy: 77.22,
    r: 28.86,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "409.1px 77.22px",
      transform: "rotate(-31.39deg)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 409.1,
    cy: 77.22,
    r: 27.04,
    fill: "#fff",
    style: {
      transformOrigin: "409.1px 77.22px",
      transform: "rotate(-31.41deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m435.53 71.48c-12.32 7.46-32.55 19.7-43.87 26.41a27.05 27.05 0 0 1-7.38-9.89l37.41-34.67a27.1 27.1 0 0 1 13.84 18.15z",
    fill: "#ebebeb",
    opacity: 0.5,
    style: {
      transformOrigin: "409.905px 75.61px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m436.12 78.16a26.73 26.73 0 0 1-1.79 8.84l-33.72 16a26.41 26.41 0 0 1-4.26-1.83c10.19-5.99 28.8-16.7 39.77-23.01z",
    fill: "#ebebeb",
    opacity: 0.5,
    style: {
      transformOrigin: "416.235px 90.58px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 408.84,
    y: 52.14,
    width: 0.52,
    height: 4.1,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "409.1px 54.19px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 397.32,
    y: 55.23,
    width: 0.52,
    height: 4.1,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "397.58px 57.28px",
      transform: "rotate(-30deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 388.9,
    y: 63.66,
    width: 0.52,
    height: 4.1,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "389.16px 65.71px",
      transform: "rotate(-60deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 384.02,
    y: 76.96,
    width: 4.1,
    height: 0.52,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "386.07px 77.22px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 387.11,
    y: 88.47,
    width: 4.1,
    height: 0.52,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "389.16px 88.73px",
      transform: "rotate(-30deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 395.54,
    y: 96.9,
    width: 4.1,
    height: 0.52,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "397.59px 97.16px",
      transform: "rotate(-60.03deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 408.84,
    y: 98.2,
    width: 0.52,
    height: 4.1,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "409.1px 100.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 420.35,
    y: 95.11,
    width: 0.52,
    height: 4.1,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "420.61px 97.16px",
      transform: "rotate(-30deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 428.78,
    y: 86.68,
    width: 0.52,
    height: 4.1,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "429.04px 88.73px",
      transform: "rotate(-60deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 430.08,
    y: 76.96,
    width: 4.1,
    height: 0.52,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "432.13px 77.22px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 426.99,
    y: 65.44,
    width: 4.1,
    height: 0.52,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "429.04px 65.7px",
      transform: "rotate(-30.01deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 418.56,
    y: 57.01,
    width: 4.1,
    height: 0.52,
    fill: "#c7c7c7",
    style: {
      transformOrigin: "420.61px 57.27px",
      transform: "rotate(-60.03deg)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "409.49 54 410.38 79.04 407.82 79.01 408.8 53.99",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "409.1px 66.515px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "425.09 68.48 408.24 79.24 407.02 76.99 424.76 67.87",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "416.055px 73.555px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M410,77.22a.88.88,0,0,1-1.75,0,.88.88,0,1,1,1.75,0Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "409.125px 77.1264px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M504.56,47.09H641.34v191H504.56Zm132.72,4.06H508.62V234H637.28Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "572.95px 142.59px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 570.92,
    y: 52.21,
    width: 4.06,
    height: 183.85,
    fill: "#ebebeb",
    style: {
      transformOrigin: "572.95px 144.135px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 500.89,
    y: 55.29,
    width: 144.13,
    height: 5.65,
    fill: "#ebebeb",
    style: {
      transformOrigin: "572.955px 58.115px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 500.89,
    y: 61.65,
    width: 144.13,
    height: 5.65,
    fill: "#ebebeb",
    style: {
      transformOrigin: "572.955px 64.475px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 500.89,
    y: 68.01,
    width: 144.13,
    height: 5.65,
    fill: "#ebebeb",
    style: {
      transformOrigin: "572.955px 70.835px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 500.89,
    y: 74.37,
    width: 144.13,
    height: 5.65,
    fill: "#ebebeb",
    style: {
      transformOrigin: "572.955px 77.195px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 500.89,
    y: 80.72,
    width: 144.13,
    height: 5.65,
    fill: "#ebebeb",
    style: {
      transformOrigin: "572.955px 83.545px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 500.89,
    y: 87.08,
    width: 144.13,
    height: 5.65,
    fill: "#ebebeb",
    style: {
      transformOrigin: "572.955px 89.905px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 500.89,
    y: 93.44,
    width: 144.13,
    height: 5.65,
    fill: "#ebebeb",
    style: {
      transformOrigin: "572.955px 96.265px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 500.89,
    y: 99.8,
    width: 144.13,
    height: 5.65,
    fill: "#ebebeb",
    style: {
      transformOrigin: "572.955px 102.625px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 500.89,
    y: 106.16,
    width: 144.13,
    height: 5.65,
    fill: "#ebebeb",
    style: {
      transformOrigin: "572.955px 108.985px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 512.94,
    y: 54.15,
    width: 1.01,
    height: 109.97,
    fill: "#a6a6a6",
    style: {
      transformOrigin: "513.445px 109.135px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "511.64 168.84 515.25 168.84 514.34 163.67 512.55 163.67",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "513.445px 166.255px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 509.28,
    y: 54.15,
    width: 1.01,
    height: 137.71,
    fill: "#a6a6a6",
    style: {
      transformOrigin: "509.785px 123.005px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "507.99 195.66 511.59 195.66 510.69 190.49 508.89 190.49",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "509.79px 193.075px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 494.59,
    y: 46.3,
    width: 156.73,
    height: 11.82,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "572.955px 52.21px",
      transform: "rotate(180deg)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    fill: "#ebebeb",
    style: {
      transformOrigin: "375px 424.376px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M705.24,439c-.15,12-148.47,20.81-330.24,22.54C192.62,463.29,44.76,451.46,44.76,439S192.61,416.47,375,416.47,705.4,426.56,705.24,439Z",
    style: {
      transformOrigin: "375px 439.091px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 311.91,
    cy: 403.76,
    rx: 117.84,
    ry: 16.72,
    style: {
      transformOrigin: "311.91px 403.76px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "375px 348.77px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "44.59 348.77 127.19 348.53 209.8 348.44 375 348.27 540.2 348.44 622.81 348.53 705.41 348.77 622.81 349.02 540.2 349.11 375 349.27 209.8 349.11 127.19 349.02",
    fill: "#263238",
    style: {
      transformOrigin: "375px 348.77px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "406.145px 268.96px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m415.07 281.48s18.29-4.14 28.31-13.38 15.62-25.78 15.62-25.78a157.78 157.78 0 0 0-20.52 5.38c-1.63 1.75-4.75 5.36-6.2 8.78a42.06 42.06 0 0 1-0.05-6.28 28.09 28.09 0 0 0-6.51 4c-8.31 7.23-10.65 27.28-10.65 27.28z",
    fill: "#ff725e",
    style: {
      transformOrigin: "437.035px 261.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M447.59,250.36c2.49-1.73,5-3.39,7.51-5.13A.15.15,0,0,0,455,245c-4.71,2.82-9.36,5.83-13.86,9q-2.34,1.65-4.62,3.41l.32-.55c.54-.91,1.12-1.82,1.7-2.72a38.43,38.43,0,0,1,3.88-5.18.06.06,0,1,0-.09-.08c-1.42,1.64-2.84,3.26-4.14,5-.62.82-1.19,1.68-1.74,2.56-.28.45-.56.91-.82,1.38l-.28.47c-2.36,1.86-4.66,3.8-6.86,5.84q-2,1.9-3.93,3.93c.71-2.21,1.32-4.45,2.14-6.63,0-.08-.09-.11-.12,0-.79,2.28-1.66,4.58-2.28,6.93-1.4,1.51-2.74,3.08-4,4.71l.06-.29q.31-1.31.66-2.58c.44-1.66.93-3.3,1.49-4.92a28.27,28.27,0,0,1,4.91-9.28c.05-.06,0-.15-.09-.09a35.75,35.75,0,0,0-7,14.63c-.19.78-.38,1.56-.55,2.34-.1.42-.21.84-.28,1.27-.55.75-1.09,1.5-1.61,2.27a79.21,79.21,0,0,0-7.74,15.18,174.15,174.15,0,0,0-5.86,18.27.09.09,0,1,0,.18.05c3.58-10.7,7.23-21.56,13.36-31.12,1.29-2,2.69-4,4.17-5.85a34.62,34.62,0,0,0,8.9-1.77,39.41,39.41,0,0,0,8.91-4.31,52.59,52.59,0,0,0,4.57-3.45c.07-.05,0-.15-.08-.09a36.3,36.3,0,0,1-8.38,5.07,46.18,46.18,0,0,1-9.23,3.1c-1.35.29-2.72.51-4.09.69a78.18,78.18,0,0,1,5.4-6c.61-.62,1.25-1.21,1.89-1.8a43.17,43.17,0,0,1,6.76-3.88c3-1.45,6-3,8.91-4.49,1.68-.85,3.34-1.72,5-2.54.07,0,0-.15-.07-.11-3,1.45-6.06,2.81-9.09,4.2-2.86,1.31-5.75,2.62-8.49,4.16l-.34.21c2.47-2.16,5-4.22,7.66-6.2Q443.85,253,447.59,250.36Z",
    fill: "#263238",
    style: {
      transformOrigin: "429.706px 277.494px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m446.55 259.79c-1.49 0.65-3 1.23-4.48 1.92s-2.95 1.53-4.39 2.38c-0.06 0 0 0.13 0.06 0.1 1.46-0.7 2.94-1.35 4.38-2.08s2.95-1.54 4.46-2.2c0.07-0.03 0.04-0.15-0.03-0.12z",
    fill: "#263238",
    style: {
      transformOrigin: "442.137px 261.99px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m355.65 189.31a26.14 26.14 0 0 1 5.46 15.19c0.06 1.64-0.2 3.92-0.39 6.61a43.43 43.43 0 0 1 11.94 10.2 21.66 21.66 0 0 0-12.06-2.88 36.61 36.61 0 0 0 0.7 5.46 20.61 20.61 0 0 1 7.76 1.54 17.4 17.4 0 0 0-7 1.39c3.26 10.37 12.95 21 39.71 25.55a56.1 56.1 0 0 0-4.77-37.66c-8-15.77-41.35-25.4-41.35-25.4z",
    fill: "#ff725e",
    style: {
      transformOrigin: "379.381px 220.84px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M411,296.76q-.71-6.64-1.74-13.26a264.9,264.9,0,0,0-5.39-26.19A105.93,105.93,0,0,0,400,245.37a17.12,17.12,0,0,0,.1-2.14c0-.86,0-1.72,0-2.57,0-1.72-.1-3.43-.25-5.14a61.88,61.88,0,0,0-1.64-10c-.49-1.91-1.06-3.79-1.62-5.67,0-.08-.14,0-.12,0a74.28,74.28,0,0,1,2,10,93.81,93.81,0,0,1,.89,10c0,.92.05,1.84.06,2.76,0,.39,0,.79,0,1.18a86,86,0,0,0-4.5-9.33,113.18,113.18,0,0,0-9.17-13.7,5.43,5.43,0,0,0-.21-1.5l-.39-1.79c-.28-1.22-.58-2.44-.92-3.65-.66-2.42-1.54-4.77-2.3-7.16,0-.08-.14,0-.12,0,.71,2.37,1.18,4.82,1.72,7.23.27,1.2.53,2.39.79,3.59l.39,1.79a.59.59,0,0,0,0,.13c-1.08-1.36-2.18-2.71-3.31-4-5.11-6-10.72-11.52-16.36-17-.69-.68-1.4-1.33-2.1-2a.06.06,0,0,0-.09.09c5.39,5.62,10.7,11.31,15.72,17.26,1.2,1.42,2.37,2.85,3.53,4.3l-1.83-1.21c-1.56-1-3.13-2-4.76-2.92s-3.26-1.8-4.93-2.63-3.55-1.54-5.2-2.5c-.07,0-.13.08-.06.11a38,38,0,0,1,4.88,2.7c1.63,1,3.26,1.94,4.86,3s3.15,2,4.71,3c1.3.85,2.59,1.77,3.94,2.55a128.21,128.21,0,0,1,8.57,12.48,92.44,92.44,0,0,1,4.43,8.41l-1-.42-2.45-1.09c-1.57-.7-3.15-1.38-4.73-2.06-3-1.31-6-2.51-9-3.94a40.18,40.18,0,0,1-4.8-2.67.06.06,0,0,0-.06.11c5.49,3.78,11.64,6.45,17.71,9.13l2.63,1.17c.73.32,1.45.68,2.2,1a93.59,93.59,0,0,1,4.52,12.4,251.55,251.55,0,0,1,5.83,25.89c1.53,8.74,2.57,17.54,3.37,26.38.1,1.1.2,2.2.33,3.3a.35.35,0,0,0,.69,0C412,305.71,411.5,301.22,411,296.76Z",
    fill: "#263238",
    style: {
      transformOrigin: "387.393px 253.457px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M394.76,222.85c-.5-2.72-1.22-5.38-1.95-8a.06.06,0,1,0-.12,0c.67,2.62,1.16,5.28,1.65,7.94s.94,5.42,1.33,8.14a0,0,0,1,0,.07,0A72.85,72.85,0,0,0,394.76,222.85Z",
    fill: "#263238",
    style: {
      transformOrigin: "394.215px 222.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M383.22,230.23A47.47,47.47,0,0,0,377.4,227c-1-.5-2-1-2.95-1.46s-2.08-.9-3.09-1.41c-.07,0-.13.07-.06.11,1,.49,1.91,1.08,2.87,1.61l3,1.62a66.7,66.7,0,0,0,5.94,3.07A.15.15,0,0,0,383.22,230.23Z",
    fill: "#263238",
    style: {
      transformOrigin: "377.299px 227.34px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m415.4 249.8s16.92-4 24.69-15.4c7.43-10.84 9.82-29.32 10-31-0.3 1.49-3.79 17.65-15.32 25.17-8.77 5.82-17.33 10.56-19.37 21.23z",
    fill: "#263238",
    opacity: 0.1,
    style: {
      transformOrigin: "432.745px 226.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m431 220.56a21.64 21.64 0 0 0-6.24 10.27s0 0.06 0.05 0a25.21 25.21 0 0 1 6.27-10.2c0.08-0.04 0-0.13-0.08-0.07z",
    fill: "#263238",
    style: {
      transformOrigin: "427.937px 225.698px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M415.4,249.8s16.92-4,24.69-15.4c7.43-10.84,9.82-29.32,10-31a.45.45,0,0,0,0-.11s-8.11,11.54-16.64,14.48S413,230.94,415.4,249.8Z",
    fill: "#ff725e",
    style: {
      transformOrigin: "432.59px 226.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M447.12,209.7a69,69,0,0,1-5.23,9,35.78,35.78,0,0,1-7,7.16c-2.3,1.83-4.73,3.48-7.06,5.27l.06-.08c.43-.65.9-1.28,1.38-1.9,1-1.23,2-2.4,3.1-3.56,2.1-2.28,4.25-4.52,6.13-7a25.89,25.89,0,0,0,2.71-4.37c0-.07-.08-.11-.11,0-2.75,5.72-8.23,9.38-12.14,14.21a25,25,0,0,0-1.57,2.14,8.77,8.77,0,0,0-1,1.72,35.88,35.88,0,0,0-5.78,5.84,25.94,25.94,0,0,1,.68-3.29,16.27,16.27,0,0,1,1.8-4.28c0-.07-.07-.14-.11-.07a20.09,20.09,0,0,0-2,4.26,15.16,15.16,0,0,0-.62,3.65h0a34.1,34.1,0,0,0-2.28,3.56l.21-1.09c.33-1.68.71-3.37,1.14-5a30.28,30.28,0,0,1,4.07-9.53.06.06,0,1,0-.1-.07A36.24,36.24,0,0,0,419,235.5c-.54,1.66-1,3.35-1.35,5.05-.19.83-.35,1.67-.51,2.51-.09.43-.18.87-.25,1.32a60.13,60.13,0,0,0-3.9,11.47,166.84,166.84,0,0,0-3.61,21.4A178,178,0,0,0,408.19,300c0,.95.07,1.9.12,2.85,0,.24.38.28.4,0,.16-3.75.26-7.51.48-11.27s.55-7.5.95-11.24a199.74,199.74,0,0,1,3.53-21.88c1.37-6.19,3.15-12.42,6.53-17.84a33.75,33.75,0,0,1,6.11-7.26c2.37-2.13,5-4,7.47-6a40.7,40.7,0,0,0,6.85-6.59,54,54,0,0,0,5.39-8.74c.39-.76.8-1.53,1.21-2.29C447.27,209.7,447.16,209.63,447.12,209.7Z",
    fill: "#263238",
    style: {
      transformOrigin: "427.708px 256.358px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m444.2 212.18a56.73 56.73 0 0 1-3.77 6.6c0 0.05 0.05 0.1 0.08 0.05a46.08 46.08 0 0 0 3.81-6.61c0.04-0.07-0.08-0.11-0.12-0.04z",
    fill: "#263238",
    style: {
      transformOrigin: "442.379px 215.497px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m353.29 242.32s-0.27 24.05 14.11 31 22.09 1.16 31.87 3.49c-0.38-0.57-7.36-10.59-18.45-13.35-11.43-2.88-24.07-11.12-27.53-21.14z",
    fill: "#ff725e",
    style: {
      transformOrigin: "376.28px 259.601px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m353.29 242.32s-0.27 24.05 14.11 31 22.09 1.16 31.87 3.49a54.85 54.85 0 0 0-16.37-4.81c-9.07-1.13-26.4-7-29.61-29.68z",
    opacity: 0.1,
    style: {
      transformOrigin: "376.28px 259.601px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M400.21,277.22a24.21,24.21,0,0,0-5.72-3.87c-.31-.15-.62-.27-.94-.4-.15-.19-.31-.37-.48-.55q-.65-.67-1.35-1.29a20.44,20.44,0,0,0-2.9-2.08c-2.38-1.41-5-2.39-7.43-3.69-.07,0-.13.08-.06.11,1.21.63,2.37,1.32,3.54,2s2.31,1.3,3.42,2a24.46,24.46,0,0,1,2.84,2.13,9.88,9.88,0,0,1,.74.71A36.59,36.59,0,0,0,387,271c-2.63-.54-5.29-.91-7.92-1.47a39.16,39.16,0,0,1-3.82-1c-1.19-1-2.38-1.92-3.51-3a29.65,29.65,0,0,1-3.72-4.12c0-.07-.15,0-.1.06a43.75,43.75,0,0,0,5.89,6.51c-.62-.24-1.23-.49-1.84-.76a29.71,29.71,0,0,1-12.25-10.2.07.07,0,0,0-.11.07,33.69,33.69,0,0,0,9.92,9.51,29.67,29.67,0,0,0,6.26,3,57.63,57.63,0,0,0,7.79,1.84,55.52,55.52,0,0,1,7.62,1.81,23.13,23.13,0,0,1,6.39,3.36,30.08,30.08,0,0,1,8.62,10.69A53.59,53.59,0,0,1,411,304.89c0,.25.43.25.41,0C410.71,294.77,408,284.25,400.21,277.22Z",
    fill: "#263238",
    style: {
      transformOrigin: "385.515px 281.042px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m383.52 269.38a8.25 8.25 0 0 0-2.95-2.68 10.77 10.77 0 0 1-3.52-2.91c-0.05-0.06-0.16 0-0.11 0.07a12 12 0 0 0 3.11 2.78 10.9 10.9 0 0 1 3.38 2.8c0.04 0.05 0.13 0 0.09-0.06z",
    fill: "#263238",
    style: {
      transformOrigin: "380.229px 266.613px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "391.15 294.98 391.81 308.2 393.81 348.61 423.98 348.61 425.99 308.2 426.64 294.98",
    fill: "#455a64",
    style: {
      transformOrigin: "408.895px 321.795px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "391.15 294.98 391.81 308.2 425.99 308.2 426.64 294.98",
    fill: "#263238",
    style: {
      transformOrigin: "408.895px 301.59px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 389.04,
    y: 289.46,
    width: 39.72,
    height: 12.62,
    fill: "#455a64",
    style: {
      transformOrigin: "408.9px 295.77px",
      transform: "rotate(180deg)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "260.951px 73.549px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m237.11 75.83a21.69 21.69 0 0 0 36.25 13.72l10.85 1.6-5.43-9.39a21.7 21.7 0 1 0-41.67-5.93z",
    fill: "#fff",
    style: {
      transformOrigin: "260.6px 73.5631px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M243.6,57.91a21.89,21.89,0,0,1,34.24,4.68,21.93,21.93,0,0,1,1.33,19.33l0-.37,5.4,9.4.39.7-.78-.12-10.85-1.67.26-.08a21.81,21.81,0,0,1-10.73,5.3,20.36,20.36,0,0,1-3,.32,23.27,23.27,0,0,1-3-.06A22.15,22.15,0,0,1,245.74,91a19.54,19.54,0,0,1-4.25-4.2,21.83,21.83,0,0,1,2.11-28.92Zm-2,28.87a23.32,23.32,0,0,0,2,2.24,22.07,22.07,0,0,0,2.29,1.91,19.75,19.75,0,0,0,5.23,2.82A21.37,21.37,0,0,0,256.84,95a21,21,0,0,0,3,0,19.47,19.47,0,0,0,2.95-.35,21.45,21.45,0,0,0,10.39-5.36l.1-.1.15,0,10.87,1.53-.39.57L278.42,82l-.11-.17.08-.2A21.39,21.39,0,0,0,277.17,63a22.45,22.45,0,0,0-6.5-7.08,21.18,21.18,0,0,0-9-3.54,21.45,21.45,0,0,0-20.16,34.43Z",
    fill: "#263238",
    style: {
      transformOrigin: "260.951px 73.549px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m266.13 73.6a2.06 2.06 0 1 0 2.05-2.06 2.05 2.05 0 0 0-2.05 2.06z",
    fill: "#263238",
    style: {
      transformOrigin: "268.19px 73.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m256.62 73.6a2.06 2.06 0 1 0 2.05-2.06 2.05 2.05 0 0 0-2.05 2.06z",
    fill: "#263238",
    style: {
      transformOrigin: "258.68px 73.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m247.11 73.6a2.06 2.06 0 1 0 2-2.06 2.05 2.05 0 0 0-2 2.06z",
    fill: "#263238",
    style: {
      transformOrigin: "249.17px 73.5991px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "542.393px 256.9px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "513.22 430.66 612.32 430.66 612.32 420.79 603.75 410.79 513.22 410.79",
    fill: "#263238",
    style: {
      transformOrigin: "562.77px 420.725px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "474.32 430.66 513.22 430.66 513.22 410.79 484.32 410.79 474.32 420.73",
    fill: "#37474f",
    style: {
      transformOrigin: "493.77px 420.725px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 575.74,
    y: 324.75,
    width: 15.3,
    height: 86.04,
    fill: "#263238",
    style: {
      transformOrigin: "583.39px 367.77px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 541.39,
    y: 324.75,
    width: 34.36,
    height: 86.04,
    fill: "#37474f",
    style: {
      transformOrigin: "558.57px 367.77px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 513.76,
    y: 381.02,
    width: 44.54,
    height: 6.92,
    fill: "#263238",
    style: {
      transformOrigin: "536.03px 384.48px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 496.27,
    y: 381.02,
    width: 17.49,
    height: 6.92,
    fill: "#37474f",
    style: {
      transformOrigin: "505.015px 384.48px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 485.15,
    y: 284.65,
    width: 143.57,
    height: 19.07,
    fill: "#37474f",
    style: {
      transformOrigin: "556.935px 294.185px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "540.1 284.65 628.72 284.65 671.69 178.57 583.07 178.57",
    fill: "#37474f",
    style: {
      transformOrigin: "605.895px 231.61px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "540.1 284.65 607.24 284.65 650.21 178.57 583.07 178.57",
    fill: "#455a64",
    style: {
      transformOrigin: "595.155px 231.61px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 485.15,
    y: 284.65,
    width: 78.77,
    height: 19.07,
    fill: "#455a64",
    style: {
      transformOrigin: "524.535px 294.185px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 583.07,
    y: 137.75,
    width: 82.87,
    height: 40.82,
    fill: "#37474f",
    style: {
      transformOrigin: "624.505px 158.16px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 583.07,
    y: 137.75,
    width: 67.14,
    height: 40.82,
    fill: "#37474f",
    style: {
      transformOrigin: "616.64px 158.16px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m574.64 158.9c0 11.07 10.7 18.6 10.7 18.6h62v-37.2h-62s-10.7 7.53-10.7 18.6z",
    fill: "#455a64",
    style: {
      transformOrigin: "610.99px 158.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m647.32 177.49v-37.19s-10.71 7.53-10.71 18.6 10.71 18.59 10.71 18.59z",
    fill: "#37474f",
    style: {
      transformOrigin: "641.965px 158.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M638.63,190.2c-4.8.21-9.59.31-14.38.39s-9.59.07-14.39.11-9.58,0-14.38-.11l-7.19-.14c-2.4-.08-4.79-.13-7.19-.25,2.4-.11,4.79-.16,7.19-.24l7.19-.14c4.8-.08,9.59-.08,14.38-.11s9.59,0,14.39.11S633.83,190,638.63,190.2Z",
    fill: "#37474f",
    style: {
      transformOrigin: "609.865px 190.207px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M628.72,215.73c-4.79.2-9.59.3-14.38.38s-9.59.07-14.38.12-9.59,0-14.39-.12l-7.19-.14c-2.39-.08-4.79-.13-7.19-.24,2.4-.12,4.8-.16,7.19-.25l7.19-.14c4.8-.08,9.59-.07,14.39-.11s9.58,0,14.38.11S623.93,215.52,628.72,215.73Z",
    fill: "#37474f",
    style: {
      transformOrigin: "599.955px 215.732px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M618.81,241.25c-4.79.21-9.58.3-14.38.38s-9.59.08-14.38.12-9.59,0-14.38-.12l-7.2-.14c-2.39-.08-4.79-.13-7.19-.24,2.4-.11,4.8-.16,7.19-.25l7.2-.13c4.79-.08,9.58-.08,14.38-.12s9.59,0,14.38.12S614,241,618.81,241.25Z",
    fill: "#37474f",
    style: {
      transformOrigin: "590.045px 241.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M608.91,266.77c-4.8.21-9.59.31-14.39.39s-9.58.07-14.38.11-9.59,0-14.38-.11l-7.19-.14c-2.4-.09-4.8-.13-7.19-.25,2.39-.11,4.79-.16,7.19-.24l7.19-.14c4.79-.08,9.59-.08,14.38-.12s9.59,0,14.38.12S604.11,266.57,608.91,266.77Z",
    fill: "#37474f",
    style: {
      transformOrigin: "580.145px 266.77px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 478.94,
    y: 303.71,
    width: 149.78,
    height: 15.58,
    fill: "#263238",
    style: {
      transformOrigin: "553.83px 311.5px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "684.44 178.57 665.91 178.57 610.19 319.29 628.72 319.29",
    fill: "#263238",
    style: {
      transformOrigin: "647.315px 248.93px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "665.94 137.75 684.44 145.02 684.44 178.57 665.94 178.57",
    fill: "#263238",
    style: {
      transformOrigin: "675.19px 158.16px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 535.71,
    y: 319.29,
    width: 74.48,
    height: 5.46,
    fill: "#a6a6a6",
    style: {
      transformOrigin: "572.95px 322.02px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m381.47 414.92c2.36 0.83 71.79-0.15 74.39-1.75 0.31-0.18 0.78-13.47 0.78-13.47 0-1.29 1.4-9.49 1.4-9.49 6.21-14.92 21-41.23 21-41.23l-45.52 1.21-21.35 42.33s-9.45 3.77-17.69 7.53c-5.08 2.31-9.49 4.42-10.51 5.21-2.66 2.07-4.85 8.84-2.5 9.66z",
    fill: "#d3766a",
    style: {
      transformOrigin: "429.755px 382.101px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M381.24,415.06c2.45.81,72.31.44,75-1.26,1-.63,1.84-23.36,1.84-23.49L413,390l0,.77s-26.67,12.08-29.38,14.26S378.8,414.26,381.24,415.06Z",
    fill: "#ff725e",
    style: {
      transformOrigin: "419.122px 402.736px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M382,412.35c11.77-.35,59.3-.65,71-.11.1,0,.1.07,0,.08-11.66.6-59.18.52-71,.23C381.77,412.54,381.77,412.36,382,412.35Z",
    fill: "#263238",
    style: {
      transformOrigin: "417.451px 412.358px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M408,390.2c4.63-.89,10.3-.21,13.87,3.07.13.13-.05.32-.2.27A66,66,0,0,0,408,390.78.29.29,0,0,1,408,390.2Z",
    fill: "#263238",
    style: {
      transformOrigin: "414.814px 391.695px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M404.62,392.23c4.63-.89,10.3-.21,13.86,3.07.14.13,0,.32-.19.27a66,66,0,0,0-13.65-2.76A.29.29,0,0,1,404.62,392.23Z",
    fill: "#263238",
    style: {
      transformOrigin: "411.439px 393.725px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M401.29,394.26c4.63-.89,10.3-.21,13.86,3.07.14.13,0,.32-.2.27a65.88,65.88,0,0,0-13.64-2.76A.29.29,0,0,1,401.29,394.26Z",
    fill: "#263238",
    style: {
      transformOrigin: "408.109px 395.755px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M457.53,401.28c-.33,6-.81,12.19-1.33,12.52-1.25.8-17.52,1.31-34.59,1.54Z",
    opacity: 0.1,
    style: {
      transformOrigin: "439.57px 408.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m411.06 390.58 53.94 0.42s35.12-87 38.57-91.55c1.72-2.28 81.2-14.05 95.1-25.82 18.05-15.3 4.73-43.79 4.73-43.79l-46.54-0.2s-2.17 11-4.07 12.49c-1.26 1-74.87 18.22-87.79 34.28-18.53 23.08-53.94 114.17-53.94 114.17z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "509.597px 310.32px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M417.58,381.8c2.86-.16,5.75,0,8.62-.05h8.62c5.75,0,11.49.06,17.24.11,3.26,0,6.51.22,9.76.36a.1.1,0,1,1,0,.19c-5.76.26-11.49.42-17.25.38s-11.49-.14-17.24-.32c-3.24-.1-6.53-.08-9.76-.38A.15.15,0,1,1,417.58,381.8Z",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "439.669px 382.261px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M464.61,366.47c1.39-3.6,2.9-7.15,4.46-10.68,3.05-6.92,16.27-37.9,19.67-45,1.67-3.51,3.33-7,5-10.52a19.29,19.29,0,0,1,2.28-3.87,9.22,9.22,0,0,1,4-2.79,52,52,0,0,1,5-1.52c1.86-.52,3.71-1,5.57-1.52q5.56-1.5,11.17-2.88c7.47-1.84,57.91-11.87,66.26-15.48a20.82,20.82,0,0,0,11-11.51c2.58-7,2.37-14.45,1.52-21.73-.22-1.88-.51-3.76-.79-5.63,0-.12.16-.16.18,0,1.12,7.36,2.4,14.87,1.18,22.31-1,6.11-4.34,12.49-9.69,15.79-10.69,6.6-68.59,16.92-83.53,21-1.83.49-3.67,1-5.49,1.52a11.06,11.06,0,0,0-4.81,2.35,13.32,13.32,0,0,0-2.63,4c-.83,1.69-1.62,3.41-2.42,5.11-3.37,7.14-23.56,52.38-29.28,66.79-.69,1.73-1.37,3.46-2.08,5.18-.09.21-.42.12-.35-.11C461.86,373.57,463.25,370,464.61,366.47Z",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "531.213px 305.371px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m435.35 426.56c2.37 0.8 70-0.16 72.63-1.81 2.82-2.68 4-66.53 4-66.53l-43.54-0.36-2.71 45.84s-9.4 3.92-17.58 7.81c-5.05 2.39-9.43 4.57-10.44 5.37-2.63 2.12-4.71 8.9-2.36 9.68z",
    fill: "#d3766a",
    style: {
      transformOrigin: "473.153px 392.353px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m434 426.61c2.45 0.81 72.31 0.47 75-1.23 1-0.63 1.56-10.8 1.87-23.1v-0.39l-45.08-0.28v0.76s-26.68 12.07-29.4 14.25-4.87 9.19-2.39 9.99z",
    fill: "#ff725e",
    style: {
      transformOrigin: "471.889px 414.32px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m434.74 423.9c11.78-0.35 59.3-0.63 71-0.08 0.1 0 0.1 0.07 0 0.08-11.66 0.59-59.19 0.49-71 0.19-0.25 0-0.25-0.18 0-0.19z",
    fill: "#263238",
    style: {
      transformOrigin: "470.184px 423.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M460.7,401.76c4.63-.89,10.3-.21,13.86,3.08.14.12,0,.32-.19.27a65.35,65.35,0,0,0-13.65-2.77A.29.29,0,0,1,460.7,401.76Z",
    fill: "#263238",
    style: {
      transformOrigin: "467.518px 403.26px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M457.37,403.79c4.63-.89,10.3-.21,13.86,3.07.13.13-.05.33-.2.28a65.26,65.26,0,0,0-13.64-2.77A.29.29,0,0,1,457.37,403.79Z",
    fill: "#263238",
    style: {
      transformOrigin: "464.182px 405.29px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M454,405.82c4.63-.89,10.3-.21,13.86,3.07.14.13,0,.32-.19.28a65.35,65.35,0,0,0-13.65-2.77A.29.29,0,0,1,454,405.82Z",
    fill: "#263238",
    style: {
      transformOrigin: "460.818px 407.319px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m463.32 402.05 49.32 0.26s-0.84-91.77 3-96.68c5.13-6.55 76.93-6.41 92.33-27.78 13.83-19.19 0-48.17 0-48.17h-49.21a83.75 83.75 0 0 0 4.44 18.65s-70.54 13.74-86.2 30.79c-12.48 13.5-13.68 122.93-13.68 122.93z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "538.718px 315.995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m556.51 245.37a25.79 25.79 0 0 1 4.61 1.48c1.56 0.59 3.1 1.27 4.6 2a88.66 88.66 0 0 1 8.6 4.86c0.09 0 0 0.17-0.08 0.13-2.94-1.53-6-2.9-9-4.21l-4.4-1.89c-1.47-0.64-3-1.18-4.44-2-0.2-0.07-0.1-0.41 0.11-0.37z",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "565.324px 249.606px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M559.77,232c.63,2.48,1.17,5,1.88,7.43.33,1.13.65,2.27,1.07,3.37.36.92.91,2,2,2.18,1.23.24,1.58-.82,1.48-1.83s-.4-2.27-.62-3.39c-.26-1.29-1.68-7.54-1.47-7.76a.1.1,0,0,1,.12,0,11.36,11.36,0,0,1,.91,2.58c.35,1.18.68,2.37,1,3.56s.6,2.39.89,3.58a5.65,5.65,0,0,1,.24,2.76,2.09,2.09,0,0,1-2,1.58l.13.24c.11.25.19.51.28.76a7.66,7.66,0,0,1,.25.77,2.7,2.7,0,0,1,.08.39c0,.14,0,.28,0,.42a.2.2,0,0,1-.38.14c-.07-.12-.16-.22-.24-.34a2.17,2.17,0,0,1-.17-.42,6.45,6.45,0,0,1-.22-.75c-.06-.25-.14-.5-.19-.75a3.73,3.73,0,0,1,0-.46,3,3,0,0,1-1.44-.54,4.82,4.82,0,0,1-1.48-2.27c-.37-1-.66-2.1-1-3.16a47.17,47.17,0,0,1-1.59-8C559.3,231.78,559.7,231.67,559.77,232Z",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "563.322px 240.356px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M586.83,235.93c.23,1.23.37,2.47.66,3.69a36.45,36.45,0,0,0,1,3.54,13,13,0,0,0,1.51,3.2,12.16,12.16,0,0,0,2.41,2.45,20.47,20.47,0,0,0,5.83,3.24,28,28,0,0,0,3.24.95,16.91,16.91,0,0,0,1.73.3,3.72,3.72,0,0,1,1.4.32.29.29,0,0,1,0,.49,5.11,5.11,0,0,1-2.58.08,18.2,18.2,0,0,1-2.75-.49,19.87,19.87,0,0,1-5.21-2.19,16.37,16.37,0,0,1-4.35-3.55,12.43,12.43,0,0,1-2.33-5.1,24.8,24.8,0,0,1-.75-6.91A.12.12,0,0,1,586.83,235.93Z",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "595.686px 245.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M505.36,340.67c.48-7.71,1.12-18.41,1.92-26.09.2-1.9.39-3.79.62-5.68a17.67,17.67,0,0,1,1-4.32c1.13-2.89,3.54-4.35,6.45-5.09,3.43-.86,7-1.38,10.48-1.95s7.16-1.09,10.74-1.59c7.26-1,14.53-1.94,21.76-3.16a172.9,172.9,0,0,0,21.35-4.8c6.43-1.94,13-4.33,18.15-8.78,11.07-9.58,11.47-25.64,10.12-39.07-.19-1.89-.42-3.79-.65-5.68,0-.1.14-.13.15,0,.88,7.56,1.9,15.17,1.14,22.79a37.14,37.14,0,0,1-6,17.66c-3.74,5.36-9.29,8.83-15.28,11.25A120,120,0,0,1,566.85,292c-14.35,3-29,4.27-43.43,6.74q-2.67.47-5.33,1a22.2,22.2,0,0,0-4.81,1.29c-3.28,1.47-4.18,4.65-4.59,7.95-.94,7.65-1.58,18.35-2.13,26-1.12,15.5-1.72,31.07-1.69,46.6,0,1.92.05,5.65.07,7.57,0,.17-.26.15-.26,0C504.21,373.56,504.38,356.21,505.36,340.67Z",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "556.643px 311.822px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M464.63,350.42c1-13.49,2.59-29.95,4.64-43.34,1-6.48,1.94-13,3.37-19.43a16.27,16.27,0,0,1,3.35-7.22,34.32,34.32,0,0,1,8-6.61c24.95-14.73,77.6-25.13,79.2-25.49a.09.09,0,1,1,0,.18c-12.77,3-57.19,14.61-75.17,24.51-2.72,1.5-10.1,5.2-12.82,10.53-1.37,2.71-2,6.84-2.54,9.79q-.9,5-1.7,10.1c-2.09,13.18-3.68,29.44-4.79,42.72S464,380.86,464,382.53a.35.35,0,0,1-.7,0C463.14,368.93,463.59,364,464.63,350.42Z",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "513.274px 315.605px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M466.79,392.43c2.65-.22,5.33-.17,8-.25l8-.2c5.33-.13,10.66-.21,16-.29,3-.05,6,.07,9.06.13a.1.1,0,0,1,0,.19c-5.32.4-10.64.69-16,.78s-10.66.14-16,.09c-3,0-6.06.07-9.06-.16A.15.15,0,0,1,466.79,392.43Z",
    fill: "#a6a6a6",
    style: {
      transformOrigin: "487.299px 392.289px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m594.33 178.67c-5.53 6.17-29.45 32-42.48 30.69-7.81-0.78-26.42-17-33.67-23.54-4.06-3.64 20-20 23.36-16.35 5.75 6.18 13.35 14.68 14.72 15.3s18.37-8.37 31.32-13.29c11.66-4.48 10.64 2.84 6.75 7.19z",
    fill: "#d3766a",
    style: {
      transformOrigin: "557.356px 189.175px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m511.85 177.56c2.47 5.24 11.71 14 14.75 15.22s18.42-14 18-17.31-10.09-20.35-15.4-22.94-19.91 19.6-17.35 25.03z",
    fill: "#d3766a",
    style: {
      transformOrigin: "528.08px 172.585px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m543.47 172.28a47.83 47.83 0 0 1 1.21-13.91c1.47-5.38 4.27-13.21 1.41-14.11-5.88-1.85-12.86 17.66-12.86 17.66s-1.69 9.11 4 11.46a6.11 6.11 0 0 0 6.24-1.1z",
    fill: "#d3766a",
    style: {
      transformOrigin: "540.161px 158.966px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M536.57,158.16c-.32,3.05-3.73.93-3.73.93s4.18,4.24,2.64,7.26-5.54.2-5.83,0c.22.23,4,4.22,2.1,7.1s-5.52-.43-5.76-.65c.14.28,1.93,4,0,5.86-3.29,3.2-8.12-6.17-11.71-7.15,0,0-2.35,5.88-2.45,6,0,0-4.79-8.82-3.2-13.58a3.21,3.21,0,0,1,3.35-2.22s-1.86-2.68-.47-5c.72-1.18,3.26-1.08,3.26-1.08a4,4,0,0,1,0-4.18c1.09-1.58,3.46-1.24,3.46-1.24s-.36-2.74,1.28-4C522.79,143.74,537.24,151.63,536.57,158.16Z",
    fill: "#d3766a",
    style: {
      transformOrigin: "522.45px 162.535px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M518.61,150.27c-.05,0,0-.1,0-.09a28.54,28.54,0,0,1,14.4,9c.12.14-.06.39-.22.26A58.35,58.35,0,0,0,518.61,150.27Z",
    fill: "#263238",
    style: {
      transformOrigin: "525.818px 154.828px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M514.73,155.62c-.06,0,0-.12,0-.11a26.75,26.75,0,0,1,15.1,10.8c.12.19,0,.48-.11.28C527.17,163.11,519.6,157.76,514.73,155.62Z",
    fill: "#263238",
    style: {
      transformOrigin: "522.292px 161.083px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m526.11 173.28c-3.56-5.14-8.4-8.62-13.88-11.48-0.07 0 0-0.13 0.06-0.11 3.06 0.66 6.37 2.85 8.8 4.77a16.56 16.56 0 0 1 5.2 6.69c0.04 0.11-0.11 0.24-0.18 0.13z",
    fill: "#263238",
    style: {
      transformOrigin: "519.249px 167.505px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M532.94,159.09c.14.17-.26.18-.13.36.56.74,3.57,5.48,2.27,7-1,1.22-3.4.67-4.22.1l-2.07-1.43,1.45,2.06a10.28,10.28,0,0,1,1.47,3,3.67,3.67,0,0,1-.21,3,2.1,2.1,0,0,1-2.45,1,6.34,6.34,0,0,1-2.69-1.71l-2.11-2.1,1.3,2.67a9.56,9.56,0,0,1,.79,2.33,4,4,0,0,1-.12,2.3,1.9,1.9,0,0,1-1.62,1.17,4.14,4.14,0,0,1-2.19-.83,31.76,31.76,0,0,1-3.93-3.36c-.64-.6-1.28-1.2-2-1.76a6.07,6.07,0,0,0-2.23-1.37,6.67,6.67,0,0,1,2.07,1.54c.62.61,1.21,1.26,1.8,1.9A28.18,28.18,0,0,0,522,178.6a4.85,4.85,0,0,0,2.6,1.08,2.69,2.69,0,0,0,2.45-1.63,4.84,4.84,0,0,0,.23-2.85,10.2,10.2,0,0,0-.84-2.61l-.81.56a7.24,7.24,0,0,0,3.16,2,3.06,3.06,0,0,0,2.06-.13,3.44,3.44,0,0,0,1.51-1.36,4.64,4.64,0,0,0,.27-3.81,11.47,11.47,0,0,0-1.68-3.26l-.62.63c1.07.69,3.64,1.6,5.5-.09C537.91,164.62,533.76,159.9,532.94,159.09Z",
    fill: "#263238",
    style: {
      transformOrigin: "525.328px 169.385px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M532.84,159.09a5.79,5.79,0,0,0,1.84.39,1.41,1.41,0,0,0,1.3-.63,2.85,2.85,0,0,0,.26-1.62c0-.62-.13-1.26-.24-1.93a4.86,4.86,0,0,1,.9,1.82,2.83,2.83,0,0,1-.19,2.19,2,2,0,0,1-1,.77,2.07,2.07,0,0,1-1.15.07A3.28,3.28,0,0,1,532.84,159.09Z",
    fill: "#263238",
    style: {
      transformOrigin: "534.939px 157.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m566.88 178.45 6.76 24.14s20.07-18.9 24.4-26.13c4.88-8.13-0.35-8.84-9.11-6.73s-22.05 8.72-22.05 8.72z",
    fill: "#ff725e",
    style: {
      transformOrigin: "583.396px 185.653px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m566.88 178.45 6.76 24.14s20.07-18.9 24.4-26.13c4.88-8.13-0.35-8.84-9.11-6.73s-22.05 8.72-22.05 8.72z",
    fill: "#030402",
    opacity: 0.1,
    style: {
      transformOrigin: "583.396px 185.653px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M571.15,177.9c.35.81,2.52,8.31,3,9.95s2.28,8.34,2.59,10.07a.06.06,0,0,1-.12,0c-.63-1.64-2.51-8.38-3-10.05s-2.45-9.13-2.56-10C571,177.85,571.12,177.85,571.15,177.9Z",
    fill: "#263238",
    style: {
      transformOrigin: "573.892px 187.919px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M615.31,258.69c-.19.12-63.82-16.9-64.22-17.71-.56-1.14,26-59.51,38.95-69,3.72-2.74,13.66-5.35,17.6.18,8.39,11.76,11,44.28,10.64,54C617.76,242.1,616,258.23,615.31,258.69Z",
    fill: "#ff725e",
    style: {
      transformOrigin: "584.697px 213.798px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M608.75,173.85l-15.07-3.77a18.75,18.75,0,0,1,2.12-.65l12.07,3C608.17,172.88,608.46,173.35,608.75,173.85Zm1.55,3.05-20.15-5-.11.08c-.33.24-.66.51-1,.82l21.83,5.46C610.67,177.77,610.49,177.33,610.3,176.9Zm1.64,4.25-25.05-6.26c-.28.3-.57.63-.86,1l26.34,6.59C612.23,182,612.09,181.58,611.94,181.15Zm1.28,4.17-29-7.24-.76,1,30.07,7.52C613.45,186.16,613.34,185.74,613.22,185.32Zm1,4.11-32.38-8.1c-.24.33-.47.66-.7,1l33.36,8.34C614.45,190.26,614.36,189.84,614.26,189.43Zm.86,4.06-35.46-8.87-.66,1,36.36,9.09Zm.73,4-38.29-9.58c-.21.34-.42.69-.64,1l39.13,9.78C616,198.34,615.92,197.93,615.85,197.52Zm.62,4-40.94-10.24-.61,1,41.72,10.42C616.59,202.33,616.53,201.93,616.47,201.52Zm.53,4-43.42-10.86c-.2.34-.4.69-.59,1l44.15,11C617.1,206.32,617.05,205.91,617,205.5Zm.44,3.95L571.68,198c-.2.34-.39.69-.58,1l46.46,11.62Zm.36,3.94-48-12c-.19.35-.38.7-.56,1.05l48.63,12.16Zm.27,3.91L568,204.79c-.19.35-.37.7-.56,1l50.7,12.67C618.12,218.11,618.1,217.71,618.07,217.3Zm.19,3.9-52-13c-.18.35-.36.7-.55,1.05l52.62,13.15C618.28,222,618.27,221.61,618.26,221.2Zm-53.79-9.6c-.18.35-.36.7-.53,1.05l54.34,13.58v-.13c0-.33,0-.68,0-1ZM562.75,215l-.52,1.06,55.9,14c0-.39,0-.78,0-1.17Zm-1.68,3.43c-.18.35-.36.7-.52,1.05l57.38,14.35c0-.39.05-.78.07-1.17Zm-1.67,3.43-.51,1.06,58.82,14.7c0-.39,0-.78.08-1.17Zm-1.64,3.43c-.16.36-.33.72-.49,1.07l60.17,15,.09-1.16Zm-1.6,3.45c-.16.36-.32.71-.49,1.06l61.47,15.37c0-.38.06-.77.1-1.16Zm-1.56,3.45-.48,1.07,62.67,15.66c0-.37.07-.76.11-1.15Zm-1.52,3.47c-.16.38-.32.73-.46,1.07l63.76,15.94c0-.37.09-.75.14-1.15Zm-1.44,3.49c-.17.44-.3.81-.39,1.09l64.63,16.15q.07-.51.18-1.14Z",
    fill: "#030402",
    opacity: 0.1,
    style: {
      transformOrigin: "584.77px 212.91px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m593.09 181c2.26 0.32 8.9-3.86 11.39-8.35 0.17-0.31-1-12.68-1-15.16 0-0.51-15.55 3.68-15.55 3.68a39.69 39.69 0 0 1 1.44 9.52 6.37 6.37 0 0 1-0.11 1v0.17c-0.37 1.91 0.5 8.63 3.83 9.14z",
    fill: "#d3766a",
    style: {
      transformOrigin: "596.214px 169.232px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m602.46 157.53c-0.61 3.76-3.07 14.26-11.66 14.41a11.3 11.3 0 0 1-1.59-0.1v-0.17a5.51 5.51 0 0 0 0.1-1 39.47 39.47 0 0 0-1.43-9.52s11.12-3 14.58-3.62z",
    fill: "#263238",
    style: {
      transformOrigin: "595.17px 164.735px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m604.94 138.24c1.87 5.45-0.51 21.45-4.3 25.12-5.51 5.33-14.78 6.13-19.37-0.54-4.46-6.47-1-27.26 3.27-30.63 6.28-4.96 17.65-1.99 20.4 6.05z",
    fill: "#d3766a",
    style: {
      transformOrigin: "592.389px 148.679px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m592.57 148.66s0.07 0.07 0.07 0.11c-0.19 1.07-0.23 2.34 0.7 2.83v0.06c-1.19-0.34-1.12-2.01-0.77-3z",
    fill: "#263238",
    style: {
      transformOrigin: "592.843px 150.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m593.69 147.68c1.76 0.11 1.39 3.61-0.23 3.5s-1.24-3.6 0.23-3.5z",
    fill: "#263238",
    style: {
      transformOrigin: "593.629px 149.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m585.94 147.92s-0.09 0-0.09 0.08c-0.08 1.09-0.36 2.32-1.37 2.58v0.06c1.21-0.04 1.52-1.64 1.46-2.72z",
    fill: "#263238",
    style: {
      transformOrigin: "585.214px 149.28px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m585.09 146.68c-1.73-0.31-2.23 3.17-0.63 3.46s2.08-3.14 0.63-3.46z",
    fill: "#263238",
    style: {
      transformOrigin: "584.723px 148.409px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M594.88,146.43a14.3,14.3,0,0,1-1.31-.62,2.35,2.35,0,0,1-1.21-.88.76.76,0,0,1,.21-.89,1.84,1.84,0,0,1,1.87,0,2.71,2.71,0,0,1,1.43,1.32A.79.79,0,0,1,594.88,146.43Z",
    fill: "#263238",
    style: {
      transformOrigin: "594.119px 145.131px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M583.63,145.13a13.31,13.31,0,0,0,1.43-.22,2.29,2.29,0,0,0,1.41-.5.75.75,0,0,0,.06-.91,1.87,1.87,0,0,0-1.79-.53,2.74,2.74,0,0,0-1.76.86A.8.8,0,0,0,583.63,145.13Z",
    fill: "#263238",
    style: {
      transformOrigin: "584.73px 144.025px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m592.19 158.55c-0.29 0.23-0.58 0.55-1 0.54a2.92 2.92 0 0 1-1.14-0.39 0 0 0 0 0-0.05 0.05 1.46 1.46 0 0 0 1.31 0.73 1.18 1.18 0 0 0 1-0.87c0-0.06-0.08-0.09-0.12-0.06z",
    fill: "#263238",
    style: {
      transformOrigin: "591.155px 159.009px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M591.38,155.19a3.64,3.64,0,0,1-2.63,1.38,4.58,4.58,0,0,1-1.33-.07,1,1,0,0,1-.25-.06l-.24-.06a.27.27,0,0,1-.19-.26h0a.45.45,0,0,1,0-.11h0v-.1c.06-.83.27-2.09.27-2.09-.32.12-1.94.66-1.87.22a55.39,55.39,0,0,1,2.59-11,.1.1,0,0,1,.19.05c-.43,3.46-1.47,6.83-2,10.31a6.5,6.5,0,0,1,1.79-.35c.12,0-.45,2.43-.45,2.81v0a5.16,5.16,0,0,0,3.94-.79C591.38,155,591.46,155.11,591.38,155.19Z",
    fill: "#263238",
    style: {
      transformOrigin: "588.274px 149.787px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M588,156.13a4.46,4.46,0,0,0,1.62,1.54,2,2,0,0,0,1.18.19c.89-.13,1-.93.91-1.62a4.72,4.72,0,0,0-.28-1.08A5.75,5.75,0,0,1,588,156.13Z",
    fill: "#263238",
    style: {
      transformOrigin: "589.868px 156.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M589.57,157.67a2,2,0,0,0,1.18.19c.89-.13,1-.93.91-1.62A2,2,0,0,0,589.57,157.67Z",
    fill: "#ff9cbd",
    style: {
      transformOrigin: "590.628px 157.057px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m604.25 153.09c-2.86-0.89-4.06-10.59-4.06-10.59s-0.09 4.1-0.85 4-3.76-5.76-4-9.76a31.21 31.21 0 0 1-7.39 3.36c-3.67 1-7.7 0.64-7.68 0 0-1.85 1.85-6.62 4.41-8.26a13 13 0 0 1 13-1.25c5.9 2.44 7.36 6.31 8.16 9.3s-0.54 13.53-1.59 13.2z",
    fill: "#263238",
    style: {
      transformOrigin: "593.177px 141.251px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M602,151.31s3.53-5.19,5.88-3.94-.26,8.75-3,9.8a2.79,2.79,0,0,1-3.76-1.44Z",
    fill: "#d3766a",
    style: {
      transformOrigin: "604.957px 152.306px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M607.06,149.5s.05.06,0,.08c-1.91.8-2.89,2.59-3.58,4.45a1.54,1.54,0,0,1,2.3-.45c.05,0,0,.11,0,.1a1.73,1.73,0,0,0-1.88.63,8.08,8.08,0,0,0-.88,1.54c-.09.17-.4.08-.34-.12v0C602.57,153.24,604.43,149.78,607.06,149.5Z",
    fill: "#263238",
    style: {
      transformOrigin: "604.877px 152.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m590.08 129.39a23.16 23.16 0 0 1 6.42-1.71c2.48-0.23 10.24 0.6 12.06 2.21s2.09 9 2.11 10-0.65 7.54-3 9-2.29-9.52-5.88-13.28-11.71-6.22-11.71-6.22z",
    fill: "#ff725e",
    style: {
      transformOrigin: "600.375px 138.333px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m590.08 129.4s8.06 2.51 11.65 6.28 3.5 14.77 5.9 13.27c1-0.65 1.58-1.66 2.06-3.37-0.4-3.23-1.55-8.26-4.13-11.8-2.42-3.31-6.69-5.07-11.3-5.73a26 26 0 0 0-4.18 1.35z",
    opacity: 0.1,
    style: {
      transformOrigin: "599.885px 138.57px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m606.79 155.47c-0.12-2.94-2.87-10.88-5.87-15.47s-12.11-7.5-13.4-7.46c-3.13 0.09-4.22 1-4.7 0.71s2.8-2.55 3.69-3.05 3.29-1.67 4.65-1.6 9.7 1.15 12.64 4.81 6.94 13.79 6.08 16.32c-0.21 0.61-1 1-1.33 1.85-0.37 1.13-0.65 2.45-1 3.24-0.32 0.63-0.75 0.9-0.76 0.65z",
    fill: "#ff725e",
    style: {
      transformOrigin: "596.385px 142.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m600.26 138a14.59 14.59 0 0 0 2.07-1.42 10.57 10.57 0 0 0 1.79-1.81s0.12 0 0.09 0.05a8.5 8.5 0 0 1-1.64 2 7.12 7.12 0 0 1-2.25 1.3c-0.09 0.02-0.14-0.12-0.06-0.12z",
    fill: "#263238",
    style: {
      transformOrigin: "602.217px 136.446px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M606.91,152.54c.08-.21.23-.39.33-.59a3.23,3.23,0,0,0,.3-.72,6.92,6.92,0,0,1,.38-1.42,5,5,0,0,1,.71-.95,1.89,1.89,0,0,0,.61-1.18c0-.06.1-.06.1,0a5,5,0,0,1-1.05,2.25,9.72,9.72,0,0,0-.45,1.51,2.27,2.27,0,0,1-.81,1.2C607,152.67,606.88,152.61,606.91,152.54Z",
    fill: "#263238",
    style: {
      transformOrigin: "608.123px 150.141px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M606,149.34c.29-.33.59-.62.85-1a8,8,0,0,0,.66-1.08c.2-.37.37-.75.55-1.12s.5-.85.7-1.3c0-.06.11,0,.09,0-.21.46-.34,1-.53,1.44a10.9,10.9,0,0,1-.6,1.18,6.57,6.57,0,0,1-.72,1,3,3,0,0,1-1,.81S606,149.36,606,149.34Z",
    fill: "#263238",
    style: {
      transformOrigin: "607.426px 147.078px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m605 146.44a8.55 8.55 0 0 0 1.65-1.75c0.44-0.65 0.85-1.33 1.25-2h0.09a10.21 10.21 0 0 1-1.08 2.2 5.54 5.54 0 0 1-0.77 0.9 5.39 5.39 0 0 1-1.08 0.7c-0.06 0.06-0.06-0.01-0.06-0.05z",
    fill: "#263238",
    style: {
      transformOrigin: "606.496px 144.602px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M603.93,143.66a3,3,0,0,0,.8-.76c.26-.32.52-.65.76-1s.48-.63.72-1a2.83,2.83,0,0,0,.55-1.06.05.05,0,0,1,.1,0,2.84,2.84,0,0,1-.37,1.13,6.88,6.88,0,0,1-.7,1.13,10,10,0,0,1-.85,1,1.91,1.91,0,0,1-1,.62C603.9,143.8,603.85,143.7,603.93,143.66Z",
    fill: "#263238",
    style: {
      transformOrigin: "605.374px 141.771px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M603.19,140.15c.28-.25.56-.51.82-.79s.5-.57.74-.87.51-.61.74-.94a0,0,0,0,1,.08,0,6.64,6.64,0,0,1-.57,1.05,7.37,7.37,0,0,1-.74.93,8,8,0,0,1-.83.82,3.15,3.15,0,0,1-1,.64c-.05,0-.11-.06-.08-.1A6,6,0,0,1,603.19,140.15Z",
    fill: "#263238",
    style: {
      transformOrigin: "603.956px 139.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M598.06,136.22a12.77,12.77,0,0,1,.93-1,13.6,13.6,0,0,1,1.07-.92,12.09,12.09,0,0,1,2.32-1.46s.1,0,.06.07c-1.43,1.15-2.9,2.24-4.31,3.4A0,0,0,0,1,598.06,136.22Z",
    fill: "#263238",
    style: {
      transformOrigin: "600.255px 134.575px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M596.36,133.66a6,6,0,0,1,1-.92,13.1,13.1,0,0,1,2.55-1.32c.06,0,.1.05,0,.08-.78.49-1.56,1-2.31,1.48a12.24,12.24,0,0,0-1.07.83c-.34.3-.61.67-.93,1a0,0,0,0,1-.06,0A3.51,3.51,0,0,1,596.36,133.66Z",
    fill: "#263238",
    style: {
      transformOrigin: "597.755px 133.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M594,132.44a6.87,6.87,0,0,1,.95-.92,7.35,7.35,0,0,1,2.18-1.19s.09.06,0,.09a14.46,14.46,0,0,0-2.07,1.4c-.32.26-.63.55-.94.82a10.77,10.77,0,0,1-.92.87s-.06,0,0,0A6.17,6.17,0,0,1,594,132.44Z",
    fill: "#263238",
    style: {
      transformOrigin: "595.172px 131.92px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M592.23,130.92c.32-.24.65-.46,1-.69a3.62,3.62,0,0,1,1-.54c.06,0,.08.06,0,.09-.62.46-1.22.93-1.83,1.41a10.08,10.08,0,0,0-1.42,1.57s-.06,0,0,0A3.83,3.83,0,0,1,592.23,130.92Z",
    fill: "#263238",
    style: {
      transformOrigin: "592.618px 131.225px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M590.05,130.38a6,6,0,0,1,2-1.16c.05,0,.09.07,0,.09a7.32,7.32,0,0,0-1.82,1.29,10.32,10.32,0,0,0-1.46,1.7s-.08,0-.06,0A5,5,0,0,1,590.05,130.38Z",
    fill: "#263238",
    style: {
      transformOrigin: "590.405px 130.76px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M587.12,131.61a4,4,0,0,1,.27-.44,4.52,4.52,0,0,1,.68-.77,10.43,10.43,0,0,1,1.7-1.24c.05,0,.1.06.05.09a8.2,8.2,0,0,0-1.6,1.27,6.69,6.69,0,0,0-.65.76c-.1.13-.19.27-.28.41a3.45,3.45,0,0,1-.25.41s-.09,0-.08,0A1.52,1.52,0,0,1,587.12,131.61Z",
    fill: "#263238",
    style: {
      transformOrigin: "588.4px 130.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M585.35,131.72c.18-.23.36-.44.56-.65a6.64,6.64,0,0,1,.63-.56l.68-.54c0-.05.12,0,.06.07a6.06,6.06,0,0,0-.64.6l-.57.6c-.19.2-.38.39-.56.6a8.37,8.37,0,0,1-.57.62,0,0,0,0,1-.06-.05A3.65,3.65,0,0,1,585.35,131.72Z",
    fill: "#263238",
    style: {
      transformOrigin: "586.088px 131.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m610.86 178.12c5.48 16.42 12.8 55.81 5.32 62.14-10.08 8.54-38 15.79-46.41 15.27-3.62-0.22-8.08-24.49-4.28-25.3 4.55-1 31.3-10.41 31.68-11.77s0.78-18.82 3.18-33.32c2.77-16.81 7.5-16.04 10.51-7.02z",
    fill: "#d3766a",
    style: {
      transformOrigin: "591.703px 213.678px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m597.67 202.94 24.49 5.35s-7.28-26.59-11.63-33.8c-4.89-8.12-8-3.84-10.22 4.89s-2.64 23.56-2.64 23.56z",
    fill: "#ff725e",
    style: {
      transformOrigin: "609.915px 189.228px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m597.67 202.94 24.49 5.35s-7.28-26.59-11.63-33.8c-4.89-8.12-8-3.84-10.22 4.89s-2.64 23.56-2.64 23.56z",
    fill: "#030402",
    opacity: 0.1,
    style: {
      transformOrigin: "609.915px 189.228px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M599.19,198.92c.88.06,8.52,1.66,10.18,2.05s8.43,1.89,10.1,2.43a.06.06,0,1,1,0,.12c-1.74-.21-8.58-1.71-10.27-2.07s-9.22-2.11-10-2.42A.06.06,0,0,1,599.19,198.92Z",
    fill: "#263238",
    style: {
      transformOrigin: "609.344px 201.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M572.6,255.48c-1.62.77-19.29,3.38-24.5,2.75a51.13,51.13,0,0,1-16-4.27c-8-3.63-13.7-6.54-14.86-9.05-1.35-2.92,1.68-4.45,14.23.18,8.28,3.06,12,.69,14.8-1.89A56.84,56.84,0,0,1,570,229.74S575.7,254,572.6,255.48Z",
    fill: "#d3766a",
    style: {
      transformOrigin: "545.234px 244.034px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m544.86 244.42c2.92-2.58-11.76 0.08-14.88-3.07s1-5 5.22-5.46c14.58-1.51 20.9-7.82 30.92-5.71s-21.26 14.24-21.26 14.24z",
    fill: "#d3766a",
    style: {
      transformOrigin: "548.492px 237.086px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 608.65,
    y: 435.65,
    width: 95.97,
    height: 4.59,
    fill: "#a6a6a6",
    style: {
      transformOrigin: "656.635px 437.945px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 475.59,
    y: 252.31,
    width: 362.09,
    height: 4.59,
    fill: "#a6a6a6",
    style: {
      transformOrigin: "656.635px 254.605px",
      transform: "rotate(-90deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M656.64,84.55H624c-7.42,0-14.92-7.34-15.23-7.65l.7-.71c.07.07,7.53,7.36,14.53,7.36h32.6Z",
    fill: "#263238",
    style: {
      transformOrigin: "632.705px 80.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m614.17 297.09c-14 0-19.92-19.41-23.9-32.59a72 72 0 0 0-3.66-10.45c-4.41-8.39-10.55-18.18-19-19.38l0.14-1c8.89 1.27 15.21 11.31 19.73 19.92a69.65 69.65 0 0 1 3.73 10.62c4.21 13.92 10.57 35 26.39 31.49 13.51-3 16.8-28.15 9.25-70.92-2.44-13.8-4.92-44.53-4.92-60.9v-30.61h1v30.61c0 16.33 2.48 47 4.9 60.73 4.44 25.12 9 67.9-10 72.07a17 17 0 0 1-3.66 0.41z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "599.677px 215.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m614.19 296.84c-13.88 0-19.72-19.3-23.68-32.41-1.34-4.42-2.49-8.24-3.68-10.5-4.44-8.44-10.63-18.3-19.17-19.51l0.07-0.5c8.77 1.25 15 11.23 19.54 19.78 1.21 2.3 2.37 6.14 3.71 10.58 4.24 14 10.65 35.18 26.68 31.66 13.67-3 17-28.28 9.45-71.2-2.44-13.79-4.92-44.5-4.92-60.86v-30.61h0.5v30.61c0 16.34 2.48 47 4.91 60.77 7.63 43.23 4.14 68.73-9.83 71.78a16.4 16.4 0 0 1-3.58 0.41z",
    fill: "#ff725e",
    style: {
      transformOrigin: "599.606px 215.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 608.5,
    y: 94.36,
    width: 27.88,
    height: 36.77,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "622.44px 112.745px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 611.15,
    y: 97.64,
    width: 22.58,
    height: 30.57,
    fill: "#ebebeb",
    style: {
      transformOrigin: "622.44px 112.925px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m611.15 128.21h22.58v-16.85a19.48 19.48 0 0 1-6.82 1.66c-4.59 0-7.22-1.5-9.59-1.66a12.24 12.24 0 0 0-6.17 1.08z",
    fill: "#ff725e",
    style: {
      transformOrigin: "622.44px 119.763px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M614.55,94.37h15.78l-1-4.08H615.55Zm7.14-2a.75.75,0,0,1,1.5,0,.75.75,0,1,1-1.5,0Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "622.44px 92.33px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 621.19,
    y: 131.14,
    width: 2.5,
    height: 4.27,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "622.44px 133.275px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m561.06 234c0 1.3 2.48 2.36 5.55 2.36s5.56-1.06 5.56-2.36-2.49-2.36-5.56-2.36-5.55 1.02-5.55 2.36z",
    fill: "#fff",
    style: {
      transformOrigin: "566.615px 234px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "626.74 105.36 626.74 107.24 623.38 107.24 623.38 110.59 621.5 110.59 621.5 107.24 618.15 107.24 618.15 105.36 621.5 105.36 621.5 102.01 623.38 102.01 623.38 105.36",
    fill: "#fff",
    style: {
      transformOrigin: "622.445px 106.3px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 621.95,
    y: 83.74,
    width: 1,
    height: 8.35,
    fill: "#263238",
    style: {
      transformOrigin: "622.45px 87.915px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "298.6px 238.873px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m241.06 406.08c2.22 0.73 65.78 0.14 68.18-1.42 0.92-0.58 1.38-9.85 1.6-21.06v-0.35c0-2.31 0.09-4.69 0.1-7.1 0-0.33-2.91-34-2.91-34l-41.54 0.27 3.11 34 0.23 6.76v0.7s-24.19 11.12-26.66 13.12-4.34 8.36-2.11 9.08z",
    fill: "#ad6359",
    style: {
      transformOrigin: "275.502px 374.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m310.7 389.42c-0.26 8.44-0.7 14.76-1.46 15.24-2.4 1.55-66 2.15-68.19 1.42s-0.32-7.12 2.12-9.1a95.77 95.77 0 0 1 9.93-5.22c-2.49 2.7-3.75 5.69 2.93 5.69 11.86 0 32.56-1.95 54.67-8.03z",
    fill: "#263238",
    style: {
      transformOrigin: "275.39px 397.904px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m267.83 382.6h45.76s-9.21-106.9-8.85-108.77c0.46-2.39 3.16-13.21 6.75-27.34 1.13-4.43 2.35-9.17 3.61-14.09 3.41-13.3 7.18-27.83 10.45-40.48 4.92-18.95 8.76-33.67 8.76-33.67h-38.79s-4.52 14.33-10.22 33c-9.28 30.3-21.68 72-22.91 82.15-1.98 16.35 5.44 109.2 5.44 109.2z",
    fill: "#37474f",
    style: {
      transformOrigin: "298.182px 270.425px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M269.85,374.79c7-.15,5-.2,12-.27,3.42,0,25.9-.23,29.09.3a.07.07,0,0,1,0,.14c-3.19.53-25.67.34-29.09.3-7-.06-5-.12-12-.27A.1.1,0,0,1,269.85,374.79Z",
    fill: "#263238",
    style: {
      transformOrigin: "290.38px 374.898px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M296.13,267.3c1.5-6.62,3.74-13.1,5.69-19.59q6-19.8,12-39.57,3-9.88,6-19.77,1.53-5,3.09-10c1-3.25,2.18-6.47,3.09-9.74.38-1.34.58-.6.1,1.09-1,3.41-1.91,6.83-2.91,10.23q-3,10.13-5.95,20.23-6,20.1-12,40.19-3,10.08-6.06,20.14a83.83,83.83,0,0,0-2.47,9.75,44.85,44.85,0,0,0-.4,10.42c.43,7,1.25,14,1.89,21l1.95,21q1.94,20.91,3.83,41.8c.16,1.77.31,3.54.45,5.3,0,.6-.37.67-.44.1-1.5-13.78-3.14-27.72-4.43-41.51s-2.57-27.46-3.86-41.19c-.32-3.45-.69-6.91-.69-10.37A42.93,42.93,0,0,1,296.13,267.3Z",
    fill: "#263238",
    style: {
      transformOrigin: "310.696px 269.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m299.93 158.25c2.69 20.84 7.82 59.9 11.56 88.24 8.75-34.34 22.82-88.24 22.82-88.24z",
    fill: "#263238",
    style: {
      transformOrigin: "317.12px 202.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M290.4,406.08c2.23.73,65.78.14,68.18-1.42.93-.58,1.38-9.85,1.61-21.06v-.35c.05-2.31.09-4.69.1-7.1,0-.33,0-.66,0-1,.15-16.18-1-33-1-33l-41.54.27,1.16,32.66,0,1.29.23,6.76,0,.7S295,395,292.52,397,288.17,405.36,290.4,406.08Z",
    fill: "#ad6359",
    style: {
      transformOrigin: "324.854px 374.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m360.05 389.42c-0.27 8.44-0.71 14.76-1.47 15.24-2.4 1.55-66 2.15-68.18 1.42s-0.33-7.12 2.12-9.1a93.55 93.55 0 0 1 9.93-5.22c-2.5 2.7-3.75 5.69 2.92 5.69 11.86 0 32.56-1.95 54.68-8.03z",
    fill: "#263238",
    style: {
      transformOrigin: "324.741px 397.904px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M296.78,158.25s.89,18.56,5.14,33.26c.34,1.22.71,2.41,1.11,3.56a68.92,68.92,0,0,1,11.18,5.74s.44,14.94.89,31.59c.5,18.62,1,39.38.91,43.79-.39,16.47,2.06,107.08,2.06,107.08l45.76.18s-8.28-101.18-8.22-107.22c.09-9.7-2.22-52.58-4-83.85a247.17,247.17,0,0,0-4.28-34.13Z",
    fill: "#37474f",
    style: {
      transformOrigin: "330.305px 270.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M319.63,375.13c7-.12,5-.18,12-.22,3.42,0,25.9-.12,29.1.42.07,0,.07.14,0,.15-3.2.51-25.68.22-29.1.17-7-.09-5-.14-12-.32A.1.1,0,0,1,319.63,375.13Z",
    fill: "#263238",
    style: {
      transformOrigin: "340.156px 375.338px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m345.79 164.88c0.84 25.53 1.73 51.07 2.87 76.58s7.16 117.27 8.7 131.5c0 0.1-0.13 0.13-0.15 0-3.33-25.33-5.19-62.81-6.82-88.3s-2.75-51-3.62-76.52c-0.49-14.44-0.87-28.88-1.3-43.31-0.01-0.17 0.31-0.15 0.32 0.05z",
    fill: "#263238",
    style: {
      transformOrigin: "351.415px 268.881px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M301.12,194a85.34,85.34,0,0,1,13.09,6.85.15.15,0,0,1-.14.27c-4.42-2.14-8.92-4.21-13.21-6.59A.3.3,0,0,1,301.12,194Z",
    fill: "#263238",
    style: {
      transformOrigin: "307.514px 197.563px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M300.87,178.22c.3,1.62.7,3.23,1.05,4.85s.57,3.06,1,4.56a7.82,7.82,0,0,0,2.12,3.83c.6.55,1.26,1,1.89,1.55.34.27.71.53,1.07.81-.05-.21-.09-.43-.13-.65-.1-.62-.21-1.24-.31-1.86-.23-1.36-.45-2.74-.66-4.11-.41-2.7-.79-5.43-1.36-8.1a.09.09,0,0,1,.17,0c.67,2.65,1.42,5.27,2,7.94.29,1.31,1.31,7.77,1.36,8.23s.09,1,.1,1.42a5.42,5.42,0,0,1,0,1.45c0,.12-.17.1-.22,0h0a5.31,5.31,0,0,1-.41-1.41c-.12-.46-.23-.93-.31-1.4,0-.17-.05-.34-.08-.51-.63-.39-1.23-.9-1.82-1.33s-1.3-.92-1.9-1.43a7.31,7.31,0,0,1-2.33-3.63,26.85,26.85,0,0,1-.76-4.65c-.2-1.83-.35-3.68-.61-5.51C300.68,178.15,300.85,178.11,300.87,178.22Z",
    fill: "#263238",
    style: {
      transformOrigin: "304.97px 188.189px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m309.42 71.71c14.31 3.32 27.89 26.71 25.78 48.57-2.27 23.63-24 32.76-38 30.86-14.89-2-22.38-16.36-18.09-26.85 4.15-10.13 13.55-14.9 14.51-23.54 0.45-4.14-1.27-11.22-0.86-17.36 0.45-6.85 8.02-13.68 16.66-11.68z",
    fill: "#263238",
    style: {
      transformOrigin: "306.664px 111.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M315.19,74.13a56.64,56.64,0,0,1,15.7,16.42,46,46,0,0,1,4.81,10.39,44.54,44.54,0,0,1,1.33,5.59,55,55,0,0,1,.61,5.71c.34,7.62-1.09,15.5-5.09,22.1a32.41,32.41,0,0,1-7.53,8.59,33,33,0,0,1-10,5.41A33.21,33.21,0,0,0,332,134a39.15,39.15,0,0,0,4.81-21.74,52.68,52.68,0,0,0-.56-5.62,43,43,0,0,0-1.28-5.5,48.27,48.27,0,0,0-4.63-10.29,56.51,56.51,0,0,0-6.79-9.06A58.18,58.18,0,0,0,315.19,74.13Z",
    fill: "#263238",
    style: {
      transformOrigin: "326.354px 111.235px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M293,91a35.94,35.94,0,0,1,.45,6.31,20,20,0,0,1-1.19,6.25,16.9,16.9,0,0,1-3.33,5.47c-1.43,1.56-2.85,3.09-4.17,4.71a31.19,31.19,0,0,0-6.21,10.73,18.76,18.76,0,0,0,.41,12.26,18.08,18.08,0,0,1-1.62-6.1,15.46,15.46,0,0,1,0-3.19,18.66,18.66,0,0,1,.58-3.14,30.62,30.62,0,0,1,6.18-11.07c1.34-1.64,2.81-3.17,4.24-4.7a17.44,17.44,0,0,0,3.29-5.2C293.28,99.52,293.32,95.21,293,91Z",
    fill: "#263238",
    style: {
      transformOrigin: "285.356px 113.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m310.2 126.77c-3 10.28-15.46 43.8-25.6 47.12-6.65 2.18-34.43 2.35-39.84-3.67-2.36-2.62-0.91-22.75 2.84-22.34s26.1 1 28.73 0 20.51-26.53 27.49-33.12c12.05-11.37 7.97 6.47 6.38 12.01z",
    fill: "#ad6359",
    style: {
      transformOrigin: "277.888px 143.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m255.78 145.6 2.48 29.76s22.2 1.73 31.15-2.84c10.87-5.54 22.64-43.23 24.11-49.36 2.43-10.07 0.58-15.7-4.55-13.54-2 0.82-4.48 2.83-7.4 6.23s-20.32 26.15-26.12 30.82c-3.24 2.59-19.67-1.07-19.67-1.07z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "285.179px 142.421px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m263.65 173.53c-0.24-4.41-1.86-22.41-2.47-26.28 0-0.27-0.22-0.31-0.21 0 0.38 13.23 2 22 2.5 26.31 0.02 0.08 0.18 0.09 0.18-0.03z",
    fill: "#263238",
    style: {
      transformOrigin: "262.31px 160.326px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M267.62,175.68c7.16,0,16.66-.54,21.8-3.15,10.86-5.55,22.63-43.24,24.1-49.37,2.43-10.07.58-15.7-4.55-13.54-.15.06-.31.14-.47.22Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "291.099px 142.421px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M351.4,175c-1.86.86-60.88-.35-60.88-.35s-2-1.7-1.26-5.72c.65-3.63,6.13-21.38,6.13-21.38a13.72,13.72,0,0,1-2.13-10.76c2.63-10.4,14.18-23.84,15.23-24.75a11.92,11.92,0,0,1,12.49-1.6c13.69,6.36,27.53,41.91,31.43,56A11.53,11.53,0,0,1,351.4,175Z",
    fill: "#ff725e",
    style: {
      transformOrigin: "320.955px 142.334px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m318.87 143.36a8.43 8.43 0 0 0-2.18-0.5 7.61 7.61 0 0 0 2 1 8.33 8.33 0 0 0 2.19 0.51 7.71 7.71 0 0 0-2.01-1.01zm10.13 27.45a7.6 7.6 0 0 0-2.18-0.49 8.67 8.67 0 0 0 4.17 1.54 8.09 8.09 0 0 0-1.99-1.05zm-28.26-40.37a7.74 7.74 0 0 0-1.81-0.45 0.84 0.84 0 0 0-0.05 0.17 9.19 9.19 0 0 0 1.66 0.83 8.33 8.33 0 0 0 2.18 0.49 8.34 8.34 0 0 0-2.03-1.04zm43 21.46a7.79 7.79 0 0 0-2.17-0.49 8 8 0 0 0 2 1 8.17 8.17 0 0 0 2.18 0.51 7.49 7.49 0 0 0-2.05-1.02zm-35.54 18.91a7.6 7.6 0 0 0-2.18-0.49 7.93 7.93 0 0 0 2 1 8.11 8.11 0 0 0 2.19 0.5 8 8 0 0 0-2.05-1.01zm27.59-43.81-0.63-0.25a7.47 7.47 0 0 0-2.17-0.5 8.34 8.34 0 0 0 2 1 7.17 7.17 0 0 0 1.2 0.35c-0.19-0.2-0.28-0.41-0.4-0.6zm-8.55-11.79a7.64 7.64 0 0 0-0.45 2 8.35 8.35 0 0 0 0.89-1.59zm18 57.12a7.8 7.8 0 0 0-0.5 2.17 7.51 7.51 0 0 0 1-2 7.8 7.8 0 0 0 0.5-2.17 7.82 7.82 0 0 0-0.97 1.97zm-26.48-10.33a7.78 7.78 0 0 0-0.49 2.18 8.16 8.16 0 0 0 1-2 8.25 8.25 0 0 0 0.5-2.18 8 8 0 0 0-1.01 2zm9.76-25.3a7.59 7.59 0 0 0-0.49 2.19 8.34 8.34 0 0 0 1-2 7.75 7.75 0 0 0 0.49-2.18 8.28 8.28 0 0 0-1 1.97zm-32.62 13.2a7.53 7.53 0 0 0-0.5 2.18 7.82 7.82 0 0 0 1-2 7.46 7.46 0 0 0 0.5-2.18 7.67 7.67 0 0 0-1 2zm9-31.27a8.33 8.33 0 0 0-0.51 2.19 7.75 7.75 0 0 0 1.06-2 8.49 8.49 0 0 0 0.49-2.19 8.54 8.54 0 0 0-1.06 2zm8.93-6.73a7.79 7.79 0 0 0-1.9 1.2 7.7 7.7 0 0 0 2.15-0.67 7.59 7.59 0 0 0 1.89-1.19 8.07 8.07 0 0 0-2.16 0.66zm22.17 49.88a8 8 0 0 0-1.9 1.18 7.62 7.62 0 0 0 2.14-0.66 7.77 7.77 0 0 0 1.89-1.18 7.76 7.76 0 0 0-2.13 0.66zm-28.25-4.24a8.36 8.36 0 0 0-1.9 1.18 7.65 7.65 0 0 0 2.13-0.66 7.83 7.83 0 0 0 1.9-1.18 7.65 7.65 0 0 0-2.14 0.66zm6.07-24.48a8.06 8.06 0 0 0-1.9 1.19 8.21 8.21 0 0 0 2.14-0.66 8.06 8.06 0 0 0 1.9-1.19 7.72 7.72 0 0 0-2.15 0.66zm28.08 6.62a8.06 8.06 0 0 0-1.19-1.9 8 8 0 0 0 0.66 2.14 7.75 7.75 0 0 0 1.19 1.9 7.62 7.62 0 0 0-0.67-2.14zm-46.23 24.73a7.75 7.75 0 0 0-1.19-1.9 8 8 0 0 0 0.66 2.13 7.75 7.75 0 0 0 1.19 1.9 7.65 7.65 0 0 0-0.67-2.13zm9.76-19.65a8.06 8.06 0 0 0-1.19-1.9 7.55 7.55 0 0 0 0.66 2.13 7.75 7.75 0 0 0 1.19 1.9 8.12 8.12 0 0 0-0.67-2.13zm44.5 18.46a8.52 8.52 0 0 0-1.18-1.89 8.65 8.65 0 0 0 1.84 4 7.72 7.72 0 0 0-0.67-2.11zm-21.14-11.85a8.21 8.21 0 0 0-1.19-1.89 8.31 8.31 0 0 0 0.66 2.14 7.51 7.51 0 0 0 1.19 1.89 7.72 7.72 0 0 0-0.67-2.14zm-7.67-27.68a7.81 7.81 0 0 0-1.19-1.89 7.55 7.55 0 0 0 0.66 2.13 8.06 8.06 0 0 0 1.19 1.9 8.19 8.19 0 0 0-0.67-2.14z",
    fill: "#fff",
    style: {
      transformOrigin: "322.535px 142.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M315.73,147.83a59.69,59.69,0,0,0-8.87-.15c-1.47.11-2.92.28-4.38.48-.73.11-1.45.18-2.18.26a9.83,9.83,0,0,1-2.3,0,.05.05,0,0,0,0,.1,14.17,14.17,0,0,0,2.15.35,14.86,14.86,0,0,0,2.11,0c1.49-.09,3-.25,4.46-.36,3-.22,6-.43,9-.43C315.87,148.08,315.87,147.84,315.73,147.83Z",
    fill: "#263238",
    style: {
      transformOrigin: "306.892px 148.244px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m322.44 151.71a64.29 64.29 0 0 0-7.14-1.66c-1.2-0.2-2.41-0.33-3.63-0.44l-1.75-0.11h-1.92c-0.07 0-0.09 0.1 0 0.11 0.6 0 1.2 0.21 1.8 0.31l1.8 0.28c1.2 0.19 2.41 0.39 3.61 0.56 2.42 0.36 4.82 0.74 7.22 1.18 0.11-0.01 0.13-0.2 0.01-0.23z",
    fill: "#263238",
    style: {
      transformOrigin: "315.231px 150.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m321 110.39s-2 154 2.22 161.21l44.8-6.11s-7.7-80.26-20.25-115.49c-11.63-32.66-26.77-39.61-26.77-39.61z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "344.273px 190.995px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m354.14 197.06a109.06 109.06 0 0 1-12.9 1c-6 0-12-0.59-13.76-0.61-0.16 0-0.23 0.51-0.13 0.52a137.62 137.62 0 0 0 13.78 1 72.13 72.13 0 0 0 12.57-1.19v3.55c-4.25 0.82-12.46 2.25-25.73 0.54 0-0.54 0-3.38-0.08-4.16 0-0.12-0.51-0.14-0.53 0-0.11 0.77-0.42 7.61-0.43 9 0 3.43 0.2 13.11 1.06 15 1.93 4.25 10.19 4.26 12.48 4.27s9.66 0.25 12.43-2.45c1.47-1.44 1.79-9.29 1.58-16.22-0.14-3.31-0.14-10.19-0.34-10.25zm-13 28.06c-7.31 0-10.49-1.52-11.61-3-1.32-1.78-1.43-4.88-1.53-8.3-0.07-2.68 0-11.1 0-11.27 4.27 0.87 15.51 2 25.72-0.34v11.16c0 2.89-0.18 7.74-1.65 9.42-1.23 1.37-5.68 2.33-10.97 2.33z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "340.734px 211.525px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m290.28 268.48c-2.44 1.21-26.2-12.81-26.2-12.81l30-106.58a20.23 20.23 0 0 1-2.74-13.61c1.32-7.6 15.31-22.9 17.88-24 0 0-2 1.38-3.89 21.68-4.44 47.53-12.62 134.12-15.05 135.32z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "286.65px 190.017px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M308.5,113.46q-1.8,2.73-3.66,5.41c-1.26,1.78-2.48,3.58-3.76,5.34l0-.41,3.35,3,.28.24-.28.27c-1.31,1.26-2.65,2.5-4,3.74l.1-.31c.63,3.2,1.29,6.39,1.86,9.6s1.16,6.42,1.68,9.64c-.8-3.17-1.53-6.35-2.24-9.54s-1.38-6.38-2.06-9.57l0-.17.14-.14c1.32-1.26,2.63-2.52,4-3.76v.51l-3.29-3-.2-.19.16-.22c1.29-1.76,2.64-3.49,3.95-5.23S307.13,115.17,308.5,113.46Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "304.135px 131.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m332.3 119.72c16.7 17.28 35.85 46.63 28.26 53.28-5 4.39-27.68-27.65-27.26-27.55 0.9 0.21-3.84-10.3-9.66-23-6.49-14.29-0.87-12.58 8.66-2.73z",
    fill: "#ad6359",
    style: {
      transformOrigin: "341.559px 142.721px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m324.12 112.16c11.87 6.62 43.45 47.25 38.49 59s-30.83-25.69-30.52-26.2-6-14.57-8.63-20.29-5.65-16.03 0.66-12.51z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "341.758px 142.443px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M324.86,131.31c.63.74,1.26,1.49,1.85,2.26.11.14.22.29.32.44l-.51-1.21a41.92,41.92,0,0,1-1.75-4.29c0-.06.08-.1.12,0a43.42,43.42,0,0,1,2.15,4.32c.68,1.41,1.37,2.83,2,4.26s1.32,2.85,1.94,4.29a32.49,32.49,0,0,1,1.69,4.32.08.08,0,0,1-.15.06,32.17,32.17,0,0,1-2.21-4.29c-.67-1.42-1.3-2.86-1.94-4.3-.27-.6-.53-1.2-.79-1.8l-.32-.41c-.3-.37-.58-.75-.86-1.14-.56-.8-1.09-1.61-1.61-2.44C324.8,131.31,324.84,131.28,324.86,131.31Z",
    fill: "#263238",
    style: {
      transformOrigin: "328.723px 137.13px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M320.67,112.07q1.2,3.25,2.48,6.48c.87,2.15,1.7,4.31,2.59,6.44l.11-.44-3.67,2.84-.3.24.21.33c1,1.58,2,3.13,3.08,4.69l-.05-.36c-1.14,3.46-2.33,6.91-3.43,10.39s-2.22,6.95-3.27,10.45c1.3-3.41,2.55-6.83,3.78-10.26s2.41-6.88,3.61-10.33l.07-.19-.11-.17c-1-1.57-2-3.15-3.07-4.7l-.09.56,3.62-2.92.23-.18-.11-.26c-.91-2.13-1.87-4.22-2.8-6.33S321.65,114.15,320.67,112.07Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "322.44px 132.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M322.3,115.51c.5-4.35-3-6.07-6.23-6.67-3.85-.71-6.44-.51-8.48,3.16a48,48,0,0,0-4.36,12.71.64.64,0,0,1-1.26-.27c1.13-5,2.84-14.2,7.94-16.68,4.69-2.28,14.49.65,13.64,8-.09.81-1.35.55-1.25-.27Z",
    fill: "#455a64",
    style: {
      transformOrigin: "312.779px 116.111px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m299.23 126.34a2.94 2.94 0 1 0 3.48-2.27 2.93 2.93 0 0 0-3.48 2.27z",
    fill: "#263238",
    style: {
      transformOrigin: "302.107px 126.946px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m300.37 126.58a1.77 1.77 0 1 0 2.1-1.37 1.77 1.77 0 0 0-2.1 1.37z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "302.103px 126.941px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M317.23,129c-3.81,12.11-3.45,15.13-2.49,16.58a8,8,0,0,0,2.77,2.46l.4-.79-.2.39.2-.39a7.45,7.45,0,0,1-2.43-2.15c-.69-1.06-1.17-3.84,2.6-15.83Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "316.091px 138.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m316.54 146.89a1 1 0 0 0 0.31 1.3l1 0.63a1 1 0 0 0 1.31-0.31 1 1 0 0 0-0.31-1.31l-1-0.62a0.94 0.94 0 0 0-1.31 0.31z",
    fill: "#263238",
    style: {
      transformOrigin: "317.852px 147.689px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M325.21,129.66c2,9.35,2.36,14.44,1.11,16a7.42,7.42,0,0,1-2.62,1.92l.33.82a8.16,8.16,0,0,0,3-2.18c1.48-1.87,1.21-6.72-.93-16.75Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "325.83px 138.935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M325.1,147.37h0a1,1,0,0,1-.43,1.27l-1.07.52a1,1,0,0,1-1.27-.43h0a1,1,0,0,1,.43-1.27l1.07-.52A.94.94,0,0,1,325.1,147.37Z",
    fill: "#263238",
    style: {
      transformOrigin: "323.715px 148.041px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M326.41,129.1A49.51,49.51,0,0,0,325.1,123a5.33,5.33,0,0,0-1.68-2.27c-.18,0,0-1.58.12-2.84a6.78,6.78,0,0,0,.07-2.79.87.87,0,0,0-1.22-.12c-.33.31-.4,1.62-.49,2.74a9.42,9.42,0,0,1-.44,2.82,5.77,5.77,0,0,0-2,1.93,41.92,41.92,0,0,0-2.4,5.93c-.35,1.3.07,1.48.44,1.63.53.21.88-.14,1.37-1.57.77-2.28,1.79-6.11,3.39-6h0c1.59.23,2,4.37,2.44,6.68.26,1.45.55,1.6,1.11,1.51C326.2,130.53,326.6,130.38,326.41,129.1Z",
    fill: "#263238",
    style: {
      transformOrigin: "321.694px 122.728px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M311.2,129.88s3.3-4.47.07-6.48-5.78,2.94-5.78,2.94Z",
    fill: "#455a64",
    style: {
      transformOrigin: "309.089px 126.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m285 159.38-0.41 5.43-0.14 1.79 1.56-0.91 4.69-2.77 20.64-33.23-5.7-3.54-20.64 33.23z",
    fill: "#455a64",
    style: {
      transformOrigin: "297.895px 146.375px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "284.56 164.81 284.42 166.6 285.98 165.69",
    fill: "#37474f",
    style: {
      transformOrigin: "285.2px 165.705px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 304.24,
    y: 127.63,
    width: 7.84,
    height: 1.55,
    fill: "#263238",
    style: {
      transformOrigin: "308.16px 128.405px",
      transform: "rotate(-148.15deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 303.34,
    y: 129.09,
    width: 7.84,
    height: 1.55,
    fill: "#263238",
    style: {
      transformOrigin: "307.26px 129.865px",
      transform: "rotate(-148.15deg)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "310.17 132.59 308.02 131.26 301.74 144.01 302.56 144.46",
    fill: "#263238",
    style: {
      transformOrigin: "305.955px 137.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m360.56 173c-6.89 6.08-33 1.38-49.45-4.45-3.13-1.1 8.52-28.92 11.73-27.4a90.53 90.53 0 0 0 10.46 4.3c0.9 0.17 34.81 20.86 27.26 27.55z",
    fill: "#ad6359",
    style: {
      transformOrigin: "336.118px 158.467px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m283.23 140.38c0.09 3.19 7.92 2.3 7.92 2.3a5.91 5.91 0 0 0-2.28 3.28c-0.52 2.37 3 4.21 3 4.21a7.24 7.24 0 0 0-1.87 3.83c-0.27 2.31 3 4.68 3 4.68a6.39 6.39 0 0 0 0.5 4.41c2 3.56 8.27 3.43 12.17 4.12a81.23 81.23 0 0 1 12.85 3.63l6.22-28.84s-17.15-9.42-21.84-9c-3.9 0.28-19.81 2.51-19.67 7.38z",
    fill: "#ad6359",
    style: {
      transformOrigin: "303.985px 151.913px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m291.21 142.59a53.29 53.29 0 0 1 12.85-2c0.09 0 0.1 0.14 0 0.15-4.27 0.25-8.57 1.64-12.82 2.06-0.1 0-0.14-0.18-0.03-0.21z",
    fill: "#263238",
    style: {
      transformOrigin: "297.638px 141.695px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m291.94 149.85a10.78 10.78 0 0 1 2.95-0.26h3.14c2.1 0 4.19 0.1 6.29 0.24a0.07 0.07 0 1 1 0 0.14h-6.27l-3.13 0.12a12.74 12.74 0 0 1-3 0 0.15 0.15 0 0 1 0.02-0.24z",
    fill: "#263238",
    style: {
      transformOrigin: "298.13px 149.878px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M293.05,158.7a7.7,7.7,0,0,1,2.67-.1l2.86.08c1.91,0,3.82.09,5.74.07.09,0,.1.14,0,.14-1.94,0-3.88.1-5.82.11h-2.86a7.25,7.25,0,0,1-2.59-.22A0,0,0,0,1,293.05,158.7Z",
    fill: "#263238",
    style: {
      transformOrigin: "298.721px 158.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m362.61 171.2c-4.95 11.78-42.78 0.72-42.78 0.72l1.9-31.48s10 5.07 10.36 4.56 35.48 14.41 30.52 26.2z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "341.46px 158.534px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m324.47 169.94c0.51-4.17 2-21.31 2-25 0-0.26-0.16-0.32-0.2-0.05-1.82 12.46-1.7 21-2 25.06 0.03 0.05 0.19 0.1 0.2-0.01z",
    fill: "#263238",
    style: {
      transformOrigin: "325.37px 157.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M322,140.45a23.49,23.49,0,0,1,3.21,1.31c.94.42,1.88.84,2.82,1.28,2,.94,4,1.93,6.05,2.94s4,2,6,3.08,3.89,2.22,5.86,3.28c.09,0,0,.18-.08.14-2-1-4.08-1.91-6.1-2.89l-6-2.87c-2-.95-4-1.89-6-2.85-1-.46-1.93-.94-2.9-1.42a23,23,0,0,1-3.08-1.6A.22.22,0,0,1,322,140.45Z",
    fill: "#263238",
    style: {
      transformOrigin: "333.82px 146.454px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M319.73,171.24c0-.21.11-.26.16,0s.05.35.08.47c1.28.28,6,1.5,7.13,1.78,2.41.6,4.78,1.31,7.23,1.74a93.55,93.55,0,0,0,10.26,1.24.08.08,0,0,1,0,.15,90.31,90.31,0,0,1-10.32-.79c-2.48-.4-5-.93-7.4-1.55-1.22-.32-2.43-.66-3.63-1a18.14,18.14,0,0,1-3.41-1.2.27.27,0,0,1-.13-.23Z",
    fill: "#263238",
    style: {
      transformOrigin: "332.171px 173.842px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M319.14,111.47c-.06,1-1.6,8.21-5.95,9.6-2.73.87-5.05-8.71-5.05-8.71l-.23-.57-3.24-8L313.35,96l1.27-1.06s.74,2.24,1.64,5c0,.13.08.26.13.4l.15.45c.14.41.28.84.41,1.27s.2.64.29,1,.2.68.3,1A55.76,55.76,0,0,1,319.14,111.47Z",
    fill: "#ad6359",
    style: {
      transformOrigin: "311.905px 108.033px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m316.26 99.93a17.29 17.29 0 0 1-8.35 11.86l-3.24-8 8.68-7.79 1.27-1.06s0.74 2.19 1.64 4.99z",
    fill: "#263238",
    style: {
      transformOrigin: "310.465px 103.365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m290.79 92.55c0.24 15.1 9.31 16.65 12.57 16.6 2.95-0.05 13-0.6 14.32-15.64s-5.77-19.7-12.54-19.94-14.59 3.88-14.35 18.98z",
    fill: "#ad6359",
    style: {
      transformOrigin: "304.312px 91.3557px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M292.68,90.63a7.26,7.26,0,0,0,1-.32,1.69,1.69,0,0,0,.94-.52.53.53,0,0,0-.07-.65,1.3,1.3,0,0,0-1.33-.17,1.9,1.9,0,0,0-1.15.82A.56.56,0,0,0,292.68,90.63Z",
    fill: "#263238",
    style: {
      transformOrigin: "293.343px 89.7532px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M302.5,89.63c-.36,0-.69-.07-1-.11a1.72,1.72,0,0,1-1-.31.54.54,0,0,1-.07-.65,1.34,1.34,0,0,1,1.28-.45,2,2,0,0,1,1.29.56A.57.57,0,0,1,302.5,89.63Z",
    fill: "#263238",
    style: {
      transformOrigin: "301.757px 88.8613px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m300.75 93.65s0.09 0 0.09 0.08c0.05 1 0.29 2.2 1.24 2.46v0.06c-1.15-0.07-1.44-1.62-1.33-2.6z",
    fill: "#263238",
    style: {
      transformOrigin: "301.404px 94.95px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m301.58 92.5c1.64-0.26 2 3 0.52 3.28s-1.89-3.06-0.52-3.28z",
    fill: "#263238",
    style: {
      transformOrigin: "301.888px 94.141px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M302.25,92.6c.31.15.63.44,1,.43s.67-.39.89-.75c0,0,.06,0,.06,0,.09.63-.08,1.31-.74,1.48s-1.12-.34-1.35-1C302,92.72,302.12,92.54,302.25,92.6Z",
    fill: "#263238",
    style: {
      transformOrigin: "303.145px 93.0365px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m295.06 94.17s-0.07 0-0.07 0.1c0.17 1 0.19 2.2-0.69 2.66a0 0 0 0 0 0 0.06c1.12-0.31 1.08-1.89 0.76-2.82z",
    fill: "#263238",
    style: {
      transformOrigin: "294.778px 95.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M294,93.22c-1.65.09-1.35,3.39.18,3.31S295.4,93.14,294,93.22Z",
    fill: "#263238",
    style: {
      transformOrigin: "294.044px 94.875px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M293.34,93.5c-.24.2-.47.54-.78.59s-.66-.28-.92-.6c0,0-.05,0-.05,0,0,.63.31,1.27.93,1.34s.92-.52,1-1.16C293.55,93.59,293.44,93.42,293.34,93.5Z",
    fill: "#263238",
    style: {
      transformOrigin: "292.558px 94.1574px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m302.27 101.36c-0.09 0.33-0.13 0.74-0.44 1a2.76 2.76 0 0 1-1.09 0.33 0 0 0 0 0 0 0.07 1.38 1.38 0 0 0 1.41-0.17 1.1 1.1 0 0 0 0.24-1.2c-0.02-0.1-0.1-0.08-0.12-0.03z",
    fill: "#263238",
    style: {
      transformOrigin: "301.607px 102.099px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M296.9,98.57s0,1.54,0,2.26c0,.07.19.08.43.07h0a3.43,3.43,0,0,0,3.18-1.64c.05-.08-.05-.14-.11-.09a5.29,5.29,0,0,1-3,1.24c-.07-.2.16-2.65.05-2.65a6.21,6.21,0,0,0-1.6.55c0-3.23.51-6.43.46-9.65a.1.1,0,0,0-.2,0A52.57,52.57,0,0,0,295.22,99C295.21,99.42,296.63,98.72,296.9,98.57Z",
    fill: "#263238",
    style: {
      transformOrigin: "297.87px 94.7345px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M297.78,100.63a3.88,3.88,0,0,0,1.66,1.06,1.78,1.78,0,0,0,1.07,0c.75-.27.7-1,.51-1.57a4.6,4.6,0,0,0-.42-.89A5.06,5.06,0,0,1,297.78,100.63Z",
    fill: "#263238",
    style: {
      transformOrigin: "299.46px 100.501px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M299.44,101.69a1.78,1.78,0,0,0,1.07,0c.75-.27.7-1,.51-1.57A1.82,1.82,0,0,0,299.44,101.69Z",
    fill: "#ff9cbd",
    style: {
      transformOrigin: "300.29px 100.946px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m317.79 92.19c-2.41 0.72-4.09-4.29-4.09-4.29s-5 1.1-8.19-5.7a11.32 11.32 0 0 0 3.5 5.44s-9 1-14.29-5.56c0 0 2.3 3.42 4 4.45a10.52 10.52 0 0 1-6.36-2.82s-0.61 4.57-1.54 6c0 0-3-15.44 11.6-16.91 0 0 9.05-1.36 13.79 5s1.58 14.39 1.58 14.39z",
    fill: "#263238",
    style: {
      transformOrigin: "304.694px 82.4694px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M315.11,92.91s2.79-5,5-4.08.48,8-1.92,9.19a2.55,2.55,0,0,1-3.54-1Z",
    fill: "#ad6359",
    style: {
      transformOrigin: "317.889px 93.5436px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M319.59,90.84s.06,0,0,.07c-1.68.89-2.43,2.61-2.9,4.36a1.4,1.4,0,0,1,2.06-.6s0,.1,0,.09a1.56,1.56,0,0,0-1.66.73,6.76,6.76,0,0,0-.68,1.47c-.07.17-.36.11-.32-.07v0C315.81,94.62,317.22,91.31,319.59,90.84Z",
    fill: "#263238",
    style: {
      transformOrigin: "317.836px 93.9503px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "257.06 179.93 294.63 176.86 273.15 130.1 235.58 133.16",
    fill: "#fff",
    style: {
      transformOrigin: "265.105px 155.015px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "254.48 180.14 292.05 177.07 270.58 130.31 233.01 133.37",
    fill: "#37474f",
    style: {
      transformOrigin: "262.53px 155.225px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M266.59,130.64a3.3,3.3,0,0,0,1.77,1.83c.37.16.43-.32.06-.47a2.42,2.42,0,0,1-1.19-1.15,2,2,0,0,1-.11-.26,1.74,1.74,0,0,1-.13-.91.59.59,0,0,1,.18-.35l0,0,.05,0,.07,0a.46.46,0,0,1,.26,0,1.08,1.08,0,0,1,.46.24,2.56,2.56,0,0,1,.41.47,1.85,1.85,0,0,1,.19.27l0,.06a.41.41,0,0,1,0,.09s0,0,0,.06l.53,0a3.67,3.67,0,0,0-.58-.89,2.08,2.08,0,0,0-1.52-.8.83.83,0,0,0-.78.84A2.23,2.23,0,0,0,266.59,130.64Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "267.7px 130.666px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M263.64,130.88a3.35,3.35,0,0,0,1.78,1.83c.37.16.43-.32.06-.47a2.42,2.42,0,0,1-1.19-1.15,2,2,0,0,1-.11-.26,1.74,1.74,0,0,1-.13-.91.59.59,0,0,1,.18-.35l0,0,.05,0,.07,0a.46.46,0,0,1,.26,0,1.08,1.08,0,0,1,.46.24,2.56,2.56,0,0,1,.41.47,3.15,3.15,0,0,1,.19.27l0,.06a.41.41,0,0,1,0,.09s0,0,0,.06l.53,0a4,4,0,0,0-.58-.89,2.08,2.08,0,0,0-1.52-.8.83.83,0,0,0-.78.84A2.32,2.32,0,0,0,263.64,130.88Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "264.76px 130.906px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M260.7,131.12a3.36,3.36,0,0,0,1.77,1.83c.38.16.44-.32.07-.47a2.42,2.42,0,0,1-1.19-1.15,1.19,1.19,0,0,1-.11-.26,1.74,1.74,0,0,1-.13-.91.59.59,0,0,1,.18-.35s0,0,0,0l.05,0,.07,0a.46.46,0,0,1,.26,0,1.08,1.08,0,0,1,.46.24,2.56,2.56,0,0,1,.41.47,3.15,3.15,0,0,1,.19.27l0,.06a.41.41,0,0,1,.05.09s0,0,0,.06l.53,0a4,4,0,0,0-.58-.89,2.08,2.08,0,0,0-1.52-.8.83.83,0,0,0-.78.84A2.3,2.3,0,0,0,260.7,131.12Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "261.87px 131.146px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M257.76,131.36a3.36,3.36,0,0,0,1.77,1.83c.38.16.43-.32.07-.47a2.49,2.49,0,0,1-1.2-1.15,2,2,0,0,1-.1-.26,1.74,1.74,0,0,1-.13-.91.59.59,0,0,1,.18-.35l0,0s0,0,0,0l.07,0a.5.5,0,0,1,.27,0,1,1,0,0,1,.45.24,2.29,2.29,0,0,1,.42.47,3.15,3.15,0,0,1,.19.27l0,.06a.41.41,0,0,1,.05.09s0,0,0,.06l.53,0a4,4,0,0,0-.58-.89,2.08,2.08,0,0,0-1.52-.8.83.83,0,0,0-.78.84A2.32,2.32,0,0,0,257.76,131.36Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "258.89px 131.386px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M254.82,131.6a3.36,3.36,0,0,0,1.77,1.83c.38.16.43-.32.07-.47a2.49,2.49,0,0,1-1.2-1.15,2,2,0,0,1-.1-.26,1.74,1.74,0,0,1-.14-.91.67.67,0,0,1,.19-.35l0,0,0,0,.07,0a.5.5,0,0,1,.27,0,1,1,0,0,1,.45.24,2.29,2.29,0,0,1,.42.47,3.15,3.15,0,0,1,.19.27l0,.06.05.09s0,0,0,.06l.53,0a4,4,0,0,0-.58-.89,2.08,2.08,0,0,0-1.52-.8.83.83,0,0,0-.78.84A2.3,2.3,0,0,0,254.82,131.6Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "255.95px 131.626px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M251.88,131.84a3.36,3.36,0,0,0,1.77,1.83c.38.16.43-.32.07-.47a2.49,2.49,0,0,1-1.2-1.15,2,2,0,0,1-.1-.26,1.74,1.74,0,0,1-.14-.91.67.67,0,0,1,.19-.35l0,0,0,0,.07,0a.5.5,0,0,1,.27,0,1,1,0,0,1,.45.24,2.29,2.29,0,0,1,.42.47,3.15,3.15,0,0,1,.19.27l0,.06a.47.47,0,0,1,.06.09s0,0,0,.06l.53,0a4,4,0,0,0-.58-.89,2.08,2.08,0,0,0-1.52-.8.83.83,0,0,0-.78.84A2.3,2.3,0,0,0,251.88,131.84Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "253.02px 131.866px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M248.94,132.08a3.36,3.36,0,0,0,1.77,1.83c.38.16.43-.31.06-.47a2.47,2.47,0,0,1-1.19-1.15,2,2,0,0,1-.1-.26,1.74,1.74,0,0,1-.14-.91.67.67,0,0,1,.19-.35l0,0s0,0,0,0l.07,0a.5.5,0,0,1,.27,0,1,1,0,0,1,.45.24,2.29,2.29,0,0,1,.42.47,3.15,3.15,0,0,1,.19.27l0,.06a.47.47,0,0,1,.06.09s0,0,0,.06l.53,0a4,4,0,0,0-.58-.89,2.1,2.1,0,0,0-1.52-.8.83.83,0,0,0-.78.84A2.3,2.3,0,0,0,248.94,132.08Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "250.08px 132.106px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M246,132.32a3.36,3.36,0,0,0,1.77,1.83c.38.16.43-.31.06-.47a2.47,2.47,0,0,1-1.19-1.15,2,2,0,0,1-.11-.26,1.84,1.84,0,0,1-.13-.91.67.67,0,0,1,.19-.35l0,0,0,0,.07,0a.5.5,0,0,1,.27,0,1,1,0,0,1,.45.24,2.29,2.29,0,0,1,.42.47,3.15,3.15,0,0,1,.19.27l0,.06a.47.47,0,0,1,.06.09s0,0,0,.06l.53,0a4,4,0,0,0-.59-.89,2.06,2.06,0,0,0-1.51-.8.83.83,0,0,0-.78.84A2.3,2.3,0,0,0,246,132.32Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "247.14px 132.346px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M243.06,132.56a3.33,3.33,0,0,0,1.77,1.83c.37.16.43-.31.06-.47a2.47,2.47,0,0,1-1.19-1.15,2,2,0,0,1-.11-.26,1.84,1.84,0,0,1-.13-.91.67.67,0,0,1,.19-.35l0,0,0,0,.07,0a.5.5,0,0,1,.27,0,1,1,0,0,1,.45.24,2.63,2.63,0,0,1,.42.47,1.81,1.81,0,0,1,.18.27l0,.06a.47.47,0,0,1,.06.09s0,0,0,.06l.53,0a4,4,0,0,0-.59-.89,2.06,2.06,0,0,0-1.51-.8.83.83,0,0,0-.78.84A2.07,2.07,0,0,0,243.06,132.56Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "244.19px 132.586px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M240.12,132.8a3.33,3.33,0,0,0,1.77,1.83c.37.16.43-.31.06-.47a2.47,2.47,0,0,1-1.19-1.15,2.72,2.72,0,0,1-.11-.25,1.78,1.78,0,0,1-.13-.92.61.61,0,0,1,.19-.35l0,0s0,0,0,0l.07,0a.5.5,0,0,1,.27,0,1,1,0,0,1,.45.24,2.63,2.63,0,0,1,.42.47,1.81,1.81,0,0,1,.18.27l0,.06a.47.47,0,0,1,.06.09s0,0,0,.06l.54,0a4,4,0,0,0-.59-.89,2.06,2.06,0,0,0-1.51-.8.83.83,0,0,0-.78.84A2.07,2.07,0,0,0,240.12,132.8Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "241.26px 132.826px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M237.18,133a3.33,3.33,0,0,0,1.77,1.83c.37.16.43-.31.06-.47a2.47,2.47,0,0,1-1.19-1.15,2,2,0,0,1-.11-.26,1.73,1.73,0,0,1-.13-.91.59.59,0,0,1,.18-.35l0,0,0,0,.07,0a.5.5,0,0,1,.27,0,1,1,0,0,1,.45.24,2.63,2.63,0,0,1,.42.47,1.81,1.81,0,0,1,.18.27l0,.06a.47.47,0,0,1,.06.09s0,0,0,.06l.54,0a4,4,0,0,0-.59-.89,2.06,2.06,0,0,0-1.51-.8.83.83,0,0,0-.78.84A2.07,2.07,0,0,0,237.18,133Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "238.31px 133.026px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M234.24,133.28a3.33,3.33,0,0,0,1.77,1.83c.37.16.43-.31.06-.47a2.47,2.47,0,0,1-1.19-1.15,2.72,2.72,0,0,1-.11-.25,1.78,1.78,0,0,1-.13-.92.59.59,0,0,1,.18-.35l0,0,0,0,.07,0a.5.5,0,0,1,.27,0,1,1,0,0,1,.45.24,2.63,2.63,0,0,1,.42.47,1.81,1.81,0,0,1,.18.27l0,.06a.2.2,0,0,1,.05.09s0,0,0,.06l.54,0a4,4,0,0,0-.59-.89,2.06,2.06,0,0,0-1.52-.8.83.83,0,0,0-.77.84A2.07,2.07,0,0,0,234.24,133.28Z",
    fill: "#c7c7c7",
    style: {
      transformOrigin: "235.36px 133.306px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M236.54,144.09c-1.34,4.33-5.46,10-5.39,13.42a3.85,3.85,0,0,0,2.7,3.73s-3.06,2.12-2.49,5.17c.3,1.56,3.06,2.47,3.06,2.47s-2.38,1.8-1.71,4.48c.54,2.13,3.23,2.72,3.23,2.72s-1.48,2.8-.24,4.79c2.53,4,21.21,1.37,23.11-5.92.89-3.4-3.64-2.5-3.64-2.5s6.2-2.87,5.74-6.74-6.26-2.34-6.26-2.34,6-2.83,5.11-6.79c-.91-4.12-6.46-1.6-6.46-1.6s3.75-3.41,2.38-6.29c-2.25-4.75-9.22,2.63-13.46,2.24L239,144.49Z",
    fill: "#ad6359",
    style: {
      transformOrigin: "246.042px 163.414px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M233.64,150.51c.91-4.21-4.74-8.43-4.45-12.58.4-5.61,7.3-1.15,9.79,6.56l.89,6.32Z",
    fill: "#ad6359",
    style: {
      transformOrigin: "234.525px 143.111px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M236.35,176.23c-.06,0-.07.1,0,.1a32.7,32.7,0,0,0,19.08-3.9c.19-.11.09-.45-.13-.37A66.93,66.93,0,0,1,236.35,176.23Z",
    fill: "#263238",
    style: {
      transformOrigin: "245.916px 174.272px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M234.33,168.93c-.07,0-.06.13,0,.13,6.56.6,14.6-1.05,20.55-5.55.21-.15.24-.5,0-.34C250.69,165.87,240.42,168.58,234.33,168.93Z",
    fill: "#263238",
    style: {
      transformOrigin: "244.665px 166.154px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m253.63 154.52c-5.88 4.09-12.47 5.89-19.51 6.76-0.09 0-0.06 0.14 0 0.15 3.55 0.51 8-0.51 11.36-1.6a18.76 18.76 0 0 0 8.27-5.11c0.11-0.09 0-0.29-0.12-0.2z",
    fill: "#263238",
    style: {
      transformOrigin: "243.929px 158.031px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "187.011px 256.9px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "236.78 430.66 137.68 430.66 137.68 420.79 146.25 410.79 236.78 410.79",
    fill: "#263238",
    style: {
      transformOrigin: "187.23px 420.725px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "275.68 430.66 236.78 430.66 236.78 410.79 265.68 410.79 275.68 420.73",
    fill: "#37474f",
    style: {
      transformOrigin: "256.23px 420.725px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 158.96,
    y: 324.75,
    width: 15.3,
    height: 86.04,
    fill: "#263238",
    style: {
      transformOrigin: "166.61px 367.77px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 174.26,
    y: 324.75,
    width: 34.36,
    height: 86.04,
    fill: "#37474f",
    style: {
      transformOrigin: "191.44px 367.77px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 191.7,
    y: 381.02,
    width: 44.54,
    height: 6.92,
    fill: "#263238",
    style: {
      transformOrigin: "213.97px 384.48px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 236.24,
    y: 381.02,
    width: 17.49,
    height: 6.92,
    fill: "#37474f",
    style: {
      transformOrigin: "244.985px 384.48px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 121.28,
    y: 284.65,
    width: 143.57,
    height: 19.07,
    fill: "#37474f",
    style: {
      transformOrigin: "193.065px 294.185px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "209.9 284.65 121.28 284.65 78.31 178.57 166.93 178.57",
    fill: "#37474f",
    style: {
      transformOrigin: "144.105px 231.61px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "209.9 284.65 142.76 284.65 99.8 178.57 166.93 178.57",
    fill: "#455a64",
    style: {
      transformOrigin: "154.85px 231.61px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 186.08,
    y: 284.65,
    width: 78.77,
    height: 19.07,
    fill: "#455a64",
    style: {
      transformOrigin: "225.465px 294.185px",
      transform: "rotate(180deg)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 84.06,
    y: 137.75,
    width: 82.87,
    height: 40.82,
    fill: "#37474f",
    style: {
      transformOrigin: "125.495px 158.16px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 99.8,
    y: 137.75,
    width: 67.14,
    height: 40.82,
    fill: "#37474f",
    style: {
      transformOrigin: "133.37px 158.16px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m175.36 158.9c0 11.07-10.7 18.6-10.7 18.6h-62v-37.2h62s10.7 7.53 10.7 18.6z",
    fill: "#455a64",
    style: {
      transformOrigin: "139.01px 158.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m102.68 177.49v-37.19s10.71 7.53 10.71 18.6-10.71 18.59-10.71 18.59z",
    fill: "#37474f",
    style: {
      transformOrigin: "108.035px 158.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M111.37,190.2c4.8-.2,9.59-.3,14.38-.38s9.59-.07,14.39-.11,9.58,0,14.38.11l7.19.14c2.4.08,4.79.13,7.19.24-2.4.12-4.79.17-7.19.25l-7.19.14c-4.8.08-9.59.07-14.38.11s-9.59,0-14.39-.11S116.17,190.41,111.37,190.2Z",
    fill: "#37474f",
    style: {
      transformOrigin: "140.135px 190.205px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M121.28,215.73c4.79-.21,9.59-.31,14.38-.39s9.59-.07,14.38-.11,9.59,0,14.39.11l7.19.14c2.39.09,4.79.13,7.19.25-2.4.11-4.8.16-7.19.24l-7.19.14c-4.8.08-9.59.08-14.39.12s-9.58,0-14.38-.12S126.07,215.93,121.28,215.73Z",
    fill: "#37474f",
    style: {
      transformOrigin: "150.045px 215.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M131.19,241.25c4.79-.21,9.58-.3,14.38-.38s9.59-.08,14.38-.12,9.59,0,14.38.12l7.2.13c2.39.09,4.79.14,7.19.25-2.4.11-4.8.16-7.19.24l-7.2.14c-4.79.08-9.58.08-14.38.12s-9.59,0-14.38-.12S136,241.46,131.19,241.25Z",
    fill: "#37474f",
    style: {
      transformOrigin: "159.955px 241.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M141.09,266.77c4.8-.2,9.59-.3,14.39-.38s9.58-.08,14.38-.12,9.59,0,14.38.12l7.19.14c2.4.08,4.8.13,7.19.24-2.39.12-4.79.16-7.19.25l-7.19.14c-4.79.08-9.59.07-14.38.11s-9.59,0-14.38-.11S145.89,267,141.09,266.77Z",
    fill: "#37474f",
    style: {
      transformOrigin: "169.855px 266.77px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 121.28,
    y: 303.71,
    width: 149.78,
    height: 15.58,
    fill: "#263238",
    style: {
      transformOrigin: "196.17px 311.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "65.56 178.57 84.09 178.57 139.81 319.29 121.28 319.29",
    fill: "#263238",
    style: {
      transformOrigin: "102.685px 248.93px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "84.06 137.75 65.56 145.02 65.56 178.57 84.06 178.57",
    fill: "#263238",
    style: {
      transformOrigin: "74.81px 158.16px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 139.81,
    y: 319.29,
    width: 74.48,
    height: 5.46,
    fill: "#a6a6a6",
    style: {
      transformOrigin: "177.05px 322.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M327.58,418.41c-2.41.81-71.36.94-74-.72-1-.62-1.61-10.66-2-22.81-.08-2.63-.15-5.34-.21-8.09a337.12,337.12,0,0,0-3.22-36.85l46.13-.22,1.95,36.85-.19,8.09s26.42,11.76,29.11,13.89S330,417.6,327.58,418.41Z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "288.391px 384.355px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m251.79 400.34c0.39 9.57 1 16.83 1.8 17.36 2.63 1.65 71.58 1.52 74 0.71s0.26-7.73-2.42-9.86c-1.19-0.93-6.93-3.73-13-6.56s6 4.84 3.79 5.54c-11.68 3.63-51.49-4.46-64.17-7.19z",
    fill: "#ff725e",
    style: {
      transformOrigin: "290.216px 409.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M162.21,226.18h25.08l7.08,14.63s63.08-.36,80,18.44c20.62,23,21.76,123.9,21.76,123.9H251.27s-6.76-81.77-12-88.6-65.56-4.84-81.94-19.33c-15.21-13.47-7.81-52.71-9-49Z",
    fill: "#263238",
    style: {
      transformOrigin: "221.842px 304.562px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M267.46,440.23c-2.52.29-69.94-14.16-72.16-16.34-.85-.82.68-10.76,2.87-22.72.47-2.58,1-5.24,1.5-7.95,3.41-17.55,7.42-36.09,7.42-36.09l45.13,9.53-8.66,35.83-1.9,7.87s23.34,17.08,25.52,19.72S270,440,267.46,440.23Z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "232.084px 398.682px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M207.1,357.13s-4,18.54-7.42,36.09c-.53,2.71-1,5.37-1.51,7.95-.34,1.85-.66,3.65-1,5.38-1.64,9.44-2.63,16.65-1.92,17.34,2.22,2.18,69.65,16.62,72.17,16.34s1.89-7.5-.27-10.14c-1-1.17-6-5.11-11.34-9.17h0c-6.83-5.18-14.16-10.55-14.16-10.55l1.89-7.87,8.66-35.83Z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "232.037px 398.682px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m197.21 406.55c-1.64 9.44-2.63 16.65-1.92 17.34 2.22 2.18 69.65 16.62 72.17 16.34s1.89-7.5-0.27-10.14c-1-1.17-6-5.11-11.34-9.17s4.85 6 2.54 6.22c-12.16 1.08-49.39-15.24-61.18-20.59z",
    fill: "#ff725e",
    style: {
      transformOrigin: "232.077px 423.392px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M246,392.22l-45.56-9.07s19.16-83.76,15.88-88c-5.42-7-46.11-6.69-66.43-20.79-16.51-11.46-8.35-48.21-8.35-48.21h43.94s4.33,8.83,5.39,13c0,0,52.05,10.5,69.34,27.46C278.09,284.06,246,392.22,246,392.22Z",
    fill: "#263238",
    style: {
      transformOrigin: "202.576px 309.185px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M264,271.54a26.15,26.15,0,0,0-8.63-9.76c-25-15.9-60.52-21.65-61.38-22-.21-.08-.29.15-.07.22,7.29,2.41,56.39,12.82,67.75,30.19,4.2,6.43,3.32,14.91,2.88,22.32-.55,9-1.61,17.94-3,26.84s-3,17.69-4.88,26.47-3.8,17.65-5.7,26.48c-.24,1.1-.44,2.21-.67,3.31a.08.08,0,1,0,.15,0c2.37-8.87,4.8-17.72,6.86-26.68s3.9-17.85,5.44-26.85a274.17,274.17,0,0,0,3.3-27.25C266.58,287.15,267.16,278.8,264,271.54Z",
    fill: "#37474f",
    style: {
      transformOrigin: "230.129px 307.741px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M131.31,174.61c-.5-2.31-.92-4.65-1.24-7a65,65,0,0,1-1.39-10.11c-.31-5.61-.31-12.41,4.57-16.16A20.28,20.28,0,0,1,141,138c2.85-.65,5.94-1,8.73.11a7.58,7.58,0,0,1,2.86,2,18.4,18.4,0,0,1,5.75,2.11c2.19.84,3.76,3,4.84,5a30.93,30.93,0,0,1,2.66,7.64,18.71,18.71,0,0,1,.59,7.4,39.29,39.29,0,0,1-1.84,6.37,22.91,22.91,0,0,0-1.58,7.83c0,.09-.14.11-.14,0-.22-4.32,1.84-8.3,2.8-12.42a16.92,16.92,0,0,0,.17-7.12,40.8,40.8,0,0,0-2.25-8,13.66,13.66,0,0,0-4.24-6l.11.09c2.27,1.94,3.38,4.84,4.21,7.63a33.34,33.34,0,0,1,1.59,9.6,31.83,31.83,0,0,1-1.56,8.7,33.72,33.72,0,0,0-1.76,8.69,25.84,25.84,0,0,0,2,9.07,37.07,37.07,0,0,1,2.44,8.67,13.05,13.05,0,0,1-1.62,7.84c-2.52,4.4-8.47,8.14-13.42,5.31A16.36,16.36,0,0,1,148,206a44.41,44.41,0,0,1-3.08-3.36,51,51,0,0,1-5.35-8.06,96,96,0,0,1-7.12-17.83c-.46-1.51-.9-3-1.31-4.55a96.23,96.23,0,0,0,2.66,10.34c2,6.1,4.42,12.27,8.12,17.55a40.43,40.43,0,0,0,3.1,3.92c1.22,1.36,2.55,2.57,3.85,3.84a.09.09,0,0,1-.11.13,33,33,0,0,1-6.4-6.63,44.84,44.84,0,0,1-4.86-8.2A87,87,0,0,1,131.31,174.61Z",
    fill: "#a3564f",
    style: {
      transformOrigin: "147.566px 173.448px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m157.47 191.91c9 18.82 22.81 33.62 30.77 34.69 11.38 1.52 30.82-18.07 37.37-27.48 2-2.87-13.79-17.48-17.35-16.31-4.62 1.52-19.53 19.23-21.24 18.6-1.22-0.46-14.13-10.48-20.52-15.6-12.85-10.27-11.72 0.47-9.03 6.1z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "190.767px 204.109px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M223.12,202.49c2.06-2.17,10.81-13,12.52-16.58s5.89-14.07,3.32-15.65-4.05,1.4-4.05,1.4,1.06-4.73-1.67-6.09-4.88,3.36-4.88,3.36.74-4.93-2.09-6.09-4.18,3.94-4.18,3.94.88-4.48-1.85-4.45c-3.29,0-4,8.47-6.16,12.23-.5.86-11.28,16.61-11.28,16.61Z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "221.287px 182.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m222.21 166.35c-0.52 6.21-1.83 8.83-5.53 13.72-0.07 0.1 0 0.23 0.14 0.13 4.06-4.46 6.17-7.51 5.7-13.84-0.03-0.31-0.28-0.31-0.31-0.01z",
    fill: "#263238",
    style: {
      transformOrigin: "219.619px 173.181px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m228.39 168.44c-1.11 6.4-2.5 9.26-6 14.67 0 0.07 0.08 0.17 0.13 0.09 3.88-5 5.92-8.11 6.19-14.66 0.01-0.29-0.27-0.39-0.32-0.1z",
    fill: "#263238",
    style: {
      transformOrigin: "225.55px 175.748px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m234.72 171.93c-1.52 6.12-2.91 9.32-7 14.13a0.12 0.12 0 1 0 0.17 0.16c4.63-4.5 6.39-8.48 7-14.23 0.11-0.39-0.07-0.45-0.17-0.06z",
    fill: "#263238",
    style: {
      transformOrigin: "231.295px 178.973px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m200.38 194.25s-0.79-7.77-0.38-11.26 6.7-15.93 9.47-14.73c3.57 1.56 1.35 9.47-0.25 13.19 0 0 8.27 3.6 7.9 9.62s-16.74 3.18-16.74 3.18z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "208.507px 181.549px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210.31,169c2.23,3.78-.18,8.53-1.45,12.27a.35.35,0,0,0,.33.49c3.36,1.74,7.59,5.17,8.11,9.13,0,.12.19.12.19,0,0-4.33-3.87-8-7.68-9.71,1.37-3.81,3.58-8.69.54-12.2C210.33,169,210.3,169,210.31,169Z",
    fill: "#263238",
    style: {
      transformOrigin: "213.16px 179.98px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m167.16 213.69 10.4-20.09s-8.55-7.49-13.87-11c-7-4.6-10.4-3.06-7.61 6.86 1.86 6.67 11.08 24.23 11.08 24.23z",
    fill: "#ff725e",
    style: {
      transformOrigin: "166.332px 196.906px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m166.32 210.66c1.31-3 2.66-6 4.15-9 0.74-1.47 4-7.19 4.77-8.65 0-0.08 0.16 0 0.12 0.07-0.77 1.89-3.75 7.69-4.5 9.16-1.49 2.93-3 5.5-4.42 8.46-0.04 0.12-0.16 0.04-0.12-0.04z",
    fill: "#263238",
    style: {
      transformOrigin: "170.839px 201.869px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M177.33,194l-10.17,19.64s-9.23-17.55-11.08-24.19c-.89-3.15-1.15-5.46-.87-7Z",
    opacity: 0.1,
    style: {
      transformOrigin: "166.216px 198.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M188,226.18l-46.45,0s-8.83-22.3-2-38.95c3.11-7.58,8.54-8.67,14.24-6.73,1.43.49,20,11.77,24.07,19.29,2.7,5-.66,11.63-.66,11.63Z",
    fill: "#ff725e",
    style: {
      transformOrigin: "162.479px 202.919px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M175,212.25a21.57,21.57,0,0,0-7.08,1.15c-1.15.36-2.29.74-3.42,1.16s-2.37.93-3.59,1.26c-.1,0-.05.17,0,.15,1.17-.3,2.34-.55,3.5-.89s2.29-.74,3.44-1.09a34.78,34.78,0,0,1,7.1-1.62A.06.06,0,0,0,175,212.25Z",
    fill: "#263238",
    style: {
      transformOrigin: "167.946px 214.111px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M176.37,214.62c-2.9-.55-5.8.07-8.67.6-.09,0-.08.17,0,.15a30.81,30.81,0,0,1,8.62-.58A.09.09,0,0,0,176.37,214.62Z",
    fill: "#263238",
    style: {
      transformOrigin: "172.028px 214.889px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M146,182.57c.37,1,6.14,7.21,10.89,6.43,1.54-.25.52-8.75.52-8.75l.07-.65.94-9-11.1-5.43-1.6-.7s-.09,2.49-.18,5.58c0,.15,0,.29,0,.44s0,.34,0,.51c0,.46,0,.93-.05,1.4s0,.71,0,1.09v1.12A59.33,59.33,0,0,0,146,182.57Z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "151.944px 176.769px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m145.55 170a18.17 18.17 0 0 0 11.94 9.57l0.94-9-11.1-5.43-1.6-0.7s-0.09 2.5-0.18 5.56z",
    fill: "#263238",
    style: {
      transformOrigin: "151.99px 172.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m167 153.23c5.9 14.79-2.3 20-5.49 21.26-2.89 1.15-12.9 4.71-20.3-9.39s-2.38-21.52 4.1-24.51 15.74-2.15 21.69 12.64z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "153.307px 157.473px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M164.47,151.26a10.23,10.23,0,0,1-1.09.16,1.78,1.78,0,0,1-1.14,0,.55.55,0,0,1-.24-.65,1.39,1.39,0,0,1,1.18-.79,2,2,0,0,1,1.47.23A.61.61,0,0,1,164.47,151.26Z",
    fill: "#263238",
    style: {
      transformOrigin: "163.424px 150.721px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M154.76,155.25c.33-.18.61-.39.93-.59s.66-.38.83-.79a.57.57,0,0,0-.24-.64,1.41,1.41,0,0,0-1.42.17,2.09,2.09,0,0,0-1,1.14A.61.61,0,0,0,154.76,155.25Z",
    fill: "#263238",
    style: {
      transformOrigin: "155.186px 154.226px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m158.17 157.71s-0.06 0.08 0 0.12c0.44 1 0.77 2.2 0 2.9v0.06c1.03-0.6 0.58-2.21 0-3.08z",
    fill: "#263238",
    style: {
      transformOrigin: "158.464px 159.252px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m156.85 157c-1.66 0.52-0.49 3.82 1.06 3.33s0.34-3.75-1.06-3.33z",
    fill: "#263238",
    style: {
      transformOrigin: "157.339px 158.671px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M156.27,157.42c-.22.29-.39.72-.72.88a1.31,1.31,0,0,1-1.2-.29s0,0,0,.06c.22.63.69,1.19,1.4,1.05s.89-.86.82-1.55C156.52,157.44,156.36,157.31,156.27,157.42Z",
    fill: "#263238",
    style: {
      transformOrigin: "155.467px 158.26px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m163.56 155.59s0.09 0 0.11 0.06c0.32 1 0.86 2.17 1.91 2.19v0.06c-1.18 0.23-1.88-1.28-2.02-2.31z",
    fill: "#263238",
    style: {
      transformOrigin: "164.57px 156.757px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m164.1 154.2c1.6-0.7 2.88 2.56 1.39 3.21s-2.73-2.62-1.39-3.21z",
    fill: "#263238",
    style: {
      transformOrigin: "164.839px 155.799px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M164.86,154.15c.33.07.71.29,1,.19s.49-.58.59-1c0-.05.05,0,.06,0,.26.62.31,1.35-.24,1.7s-1.11-.05-1.5-.62C164.71,154.33,164.73,154.12,164.86,154.15Z",
    fill: "#263238",
    style: {
      transformOrigin: "165.718px 154.244px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m160.87 166.19c0.32 0.17 0.67 0.43 1 0.34a2.86 2.86 0 0 0 1-0.6 0 0 0 0 1 0.06 0 1.49 1.49 0 0 1-1.14 1 1.17 1.17 0 0 1-1.1-0.67c0.06-0.05 0.13-0.09 0.18-0.07z",
    fill: "#263238",
    style: {
      transformOrigin: "161.81px 166.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M163.76,160.94s.77,1.45,1,2.16c0,.07-.14.16-.38.27h0a3.62,3.62,0,0,1-3.77,0c-.08-.05,0-.16.07-.14a5.41,5.41,0,0,0,3.44-.26c0-.21-1.41-2.42-1.3-2.47a6.38,6.38,0,0,1,1.77-.23c-1.52-3-3.52-5.83-5-8.89-.05-.11.1-.21.17-.12a55.77,55.77,0,0,1,5.77,9.35C165.77,161,164.09,161,163.76,160.94Z",
    fill: "#263238",
    style: {
      transformOrigin: "162.567px 157.562px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m142.17 165.9a6.47 6.47 0 0 0 1.9-6.09 16.86 16.86 0 0 0 4.93-7.31c0 0.34 0 2.79-0.1 4 8.95-4.71 9.65-12.88 9.65-12.88a17.12 17.12 0 0 1 6 4.74s-1.73-5.85-5.93-8.82c-5.14-3.65-17.92-1.12-21.73 6.88-4.09 8.66 5.28 19.48 5.28 19.48z",
    fill: "#a3564f",
    style: {
      transformOrigin: "150.203px 151.902px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M155.64,152.74a18.37,18.37,0,0,1-4.32,3.29s0,0,0,0a15.53,15.53,0,0,0,5.68-6.37,14.76,14.76,0,0,0,1.16-3.49,10.23,10.23,0,0,0,.15-4c0-.1.13-.13.15,0a12.16,12.16,0,0,1,.4,4,11,11,0,0,1-1.14,3.8,12.61,12.61,0,0,1-2.06,2.86",
    fill: "#a3564f",
    style: {
      transformOrigin: "155.103px 149.057px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m143.32 170.56a3.12 3.12 0 0 0 0.76 0 2.54 2.54 0 0 0 1.52-0.75 2.52 2.52 0 0 0 0.44-0.62 3 3 0 0 0 0.32-1l-2.07-3.81s-4.77-3.76-6.56-1.92 2.77 7.92 5.59 8.1z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "141.843px 166.268px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M139.08,164.13a0,0,0,0,0,0,.07c2,.18,3.42,1.55,4.59,3.06a1.48,1.48,0,0,0-2.24.25.05.05,0,0,0,.07.08,1.69,1.69,0,0,1,1.92,0,8.63,8.63,0,0,1,1.26,1.16c.13.13.39,0,.27-.2l0,0C144.3,166.26,141.58,163.62,139.08,164.13Z",
    fill: "#263238",
    style: {
      transformOrigin: "142.03px 166.434px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M143.34,169.85a.74.74,0,1,0,1.3-.69.74.74,0,0,0-1.3.69Z",
    fill: "#fff",
    style: {
      transformOrigin: "144.027px 169.574px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M141.57,169.23a.51.51,0,0,0,.7.21.52.52,0,1,0-.7-.21Z",
    fill: "#fff",
    style: {
      transformOrigin: "142.026px 168.982px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m138.59 192.62c-2.78 17.6-5.14 42-0.15 48.29 3.65 4.59 34 11.92 43.58 14 3.42 0.73 11.7-22.87 8.13-24-4.65-1.47-35.52-6.48-36.26-8.65-0.42-1.23-3.57-21.06-5.37-29.65-3.37-16.12-8.96-6.15-9.93 0.01z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "163.277px 219.401px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M180.39,254.62c1.64.68,17.27,3,22.41,2.33a50.25,50.25,0,0,0,15.76-4.26c7.86-3.62,13.51-6.51,14.64-9,1.32-2.89-1.68-4.39-14,.22-8.16,3.05-11.9.73-14.62-1.81a56,56,0,0,0-23.44-13.2S174.08,252,180.39,254.62Z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "205.627px 242.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M206,243.31c-2.9-2.54,11.61,0,14.68-3.08s-1-5-5.17-5.38c-14.41-1.44-20.67-7.65-30.55-5.53S206,243.31,206,243.31Z",
    fill: "#f7a9a0",
    style: {
      transformOrigin: "202.383px 236.097px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m133.48 215.64 20.13-10.31s-2.6-11.06-4.91-17c-3.06-7.84-6.68-8.54-10.18 1.15-2.35 6.52-5.04 26.16-5.04 26.16z",
    fill: "#ff725e",
    style: {
      transformOrigin: "143.545px 198.985px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.63,206.37a20.21,20.21,0,0,1,1.93-1.09c-.34-1.29-.7-2.58-1-3.88-.16-.65-.31-1.3-.46-2s-.37-1.53-.51-2.16a.07.07,0,1,1,.14,0c.26.81.43,1.42.65,2.12.16.5.3,1,.44,1.51,0-.14,0-.28,0-.41,0-.74,0-1.46-.06-2.2,0-.09.13-.1.14,0,0,.74.17,1.46.22,2.19a10.32,10.32,0,0,1,.06,1.67c.31,1.08.77,2.27,1,3.35a19.51,19.51,0,0,1-2.5,1S151.6,206.39,151.63,206.37Z",
    fill: "#263238",
    style: {
      transformOrigin: "152.885px 201.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m134.54 212.68c2.83-1.7 5.67-3.36 8.6-4.89 1.46-0.77 7.44-3.52 8.91-4.26 0.08 0 0.13 0.08 0 0.13-1.72 1.09-7.52 4.07-9 4.83-2.92 1.52-5.64 2.73-8.52 4.32-0.01 0.04-0.06-0.08 0.01-0.13z",
    fill: "#263238",
    style: {
      transformOrigin: "143.317px 208.174px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 45.38,
    y: 435.65,
    width: 95.97,
    height: 4.59,
    fill: "#a6a6a6",
    style: {
      transformOrigin: "93.365px 437.945px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: -87.68,
    y: 252.31,
    width: 362.09,
    height: 4.59,
    fill: "#a6a6a6",
    style: {
      transformOrigin: "93.365px 254.605px",
      transform: "rotate(-90deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M126,84.55H93.36v-1H126c7,0,14.46-7.29,14.53-7.36l.7.71C140.88,77.21,133.38,84.55,126,84.55Z",
    fill: "#263238",
    style: {
      transformOrigin: "117.295px 80.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m135.83 297.09a17 17 0 0 1-3.65-0.41c-19.06-4.17-14.46-47-10-72.07 2.43-13.76 4.91-44.4 4.91-60.73v-30.61h1v30.61c0 16.37-2.48 47.1-4.92 60.9-7.55 42.77-4.27 68 9.25 70.92 15.82 3.46 22.18-17.57 26.39-31.49a69.65 69.65 0 0 1 3.73-10.62c4.52-8.61 10.84-18.65 19.73-19.92l0.14 1c-8.44 1.2-14.58 11-19 19.38a72 72 0 0 0-3.66 10.45c-4 13.18-9.87 32.59-23.92 32.59z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "150.324px 215.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m135.81 296.84a16.33 16.33 0 0 1-3.58-0.41c-18.85-4.12-14.25-46.74-9.83-71.78 2.43-13.77 4.91-44.43 4.91-60.77v-30.61h0.5v30.61c0 16.36-2.48 47.07-4.92 60.86-7.58 42.92-4.22 68.21 9.45 71.2 16 3.51 22.44-17.65 26.68-31.66 1.34-4.44 2.5-8.28 3.71-10.58 4.49-8.55 10.77-18.53 19.54-19.78l0.07 0.5c-8.54 1.21-14.73 11.07-19.17 19.51-1.19 2.26-2.34 6.08-3.68 10.5-3.96 13.1-9.8 32.4-23.68 32.41z",
    fill: "#ff725e",
    style: {
      transformOrigin: "150.407px 215.055px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 113.62,
    y: 94.36,
    width: 27.88,
    height: 36.77,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "127.56px 112.745px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 116.27,
    y: 97.64,
    width: 22.58,
    height: 30.57,
    fill: "#ebebeb",
    style: {
      transformOrigin: "127.56px 112.925px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m138.85 128.21h-22.58v-16.85a19.48 19.48 0 0 0 6.82 1.66c4.59 0 7.22-1.5 9.59-1.66a12.24 12.24 0 0 1 6.17 1.08z",
    fill: "#ff725e",
    style: {
      transformOrigin: "127.56px 119.763px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M134.45,90.29H120.67l-1,4.08h15.78Zm-6.89,2.79a.75.75,0,0,1,0-1.5.75.75,0,0,1,0,1.5Z",
    fill: "#dbdbdb",
    style: {
      transformOrigin: "127.56px 92.33px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 126.31,
    y: 131.14,
    width: 2.5,
    height: 4.27,
    fill: "#dbdbdb",
    style: {
      transformOrigin: "127.56px 133.275px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m188.94 234c0 1.3-2.48 2.36-5.55 2.36s-5.56-1.06-5.56-2.36 2.49-2.36 5.56-2.36 5.55 1.02 5.55 2.36z",
    fill: "#fff",
    style: {
      transformOrigin: "183.385px 234px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "131.85 105.36 131.85 107.24 128.5 107.24 128.5 110.59 126.61 110.59 126.61 107.24 123.27 107.24 123.27 105.36 126.61 105.36 126.61 102.01 128.5 102.01 128.5 105.36",
    fill: "#fff",
    style: {
      transformOrigin: "127.56px 106.3px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 127.06,
    y: 83.74,
    width: 1,
    height: 8.35,
    fill: "#263238",
    style: {
      transformOrigin: "127.56px 87.915px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonateImage1);
export default __webpack_public_path__ + "static/media/donate_image1.4d133c22cf8e1cacf7c6128d61f3ed55.svg";
export { ForwardRef as ReactComponent };